// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:59:12.655Z
// Property: Creekside Apartment Homes (ID: 6767906449167594)
// Collections: 30 amenities, 4 floorplans (live), 40 photos, 73 POIs, 11 reviews, 4 virtual tours, 6 office hours, 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167594",
  "property_external_id": "1124089",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/creekside-apartment-homes-overland-park-ks/eycnlqn/",
  "property_google_business_url": "https://www.google.com/maps/place/Creekside+Apartment+Homes/@38.9120333,-94.7280876,890m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0954ac0641967:0xb0400f3de7f3da9f!8m2!3d38.9120333!4d-94.7280876!16s%2Fg%2F1wb8v6fl?entry=ttu&g_ep=EgoyMDI2MDkwOS4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124089 p1099041",
  "property_status": null,
  "property_slug": "creekside-apartment-homes",
  "property_name": "Creekside Apartment Homes",
  "property_website_url": "https://www.creeksideaptskc.com/",
  "property_domain": "https://www.creeksideaptskc.com/",
  "property_address": "11920 Oakmont St",
  "property_full_address": "11920 Oakmont St, Overland Park, KS 66213",
  "property_address_1": "11920 Oakmont St",
  "property_address_2": null,
  "property_address_city": "Overland Park",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66213",
  "property_address_country": "US",
  "property_address_county": "Johnson County",
  "property_neighborhood_address": "Creekside",
  "property_address_latitude": "38.9120223",
  "property_address_longitude": "-94.72811709999999",
  "property_email": "rentcafe.ck@pricekc.com",
  "property_phone": "(913) 557-8304",
  "property_call_tracking_phone": "913-557-8304",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Creekside Apartment Homes brings Overland Park living right to the trail.</strong> Explore smoke-free one-, two-, and three-bedroom apartments with everyday comforts, inviting community spaces, and direct access to nearby parks and paths—then schedule your tour today.</p>",
  "property_long_description": "<p>Welcome to Creekside Apartment Homes, a pet-friendly community offering one-, two-, and three-bedroom apartments for rent in Overland Park, Kansas. Each home includes nine-foot or vaulted ceilings, a private patio or balcony, spacious closets and pantries, and an in-home washer and dryer, with select apartments featuring a sunroom with a built-in desk and closet.</p><p>Take advantage of community amenities including a swimming pool, a fitness center, a business center, a clubhouse with a coffee bar, and covered parking with carports and detached garages. Our location near 119th Street keeps Johnson County Community College, Saint Luke’s South Hospital, and Oak Park Mall within easy reach.</p><p>Browse our <a href=\"/gallery\">photo gallery</a>, explore the <a href=\"/neighborhood\">Overland Park neighborhood</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> of Creekside Apartment Homes today.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-9569-73a0-b24d-cca99bf0f656.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at a multifamily property.",
    "public_id": "01a0101e-9569-73a0-b24d-cca99bf0f656",
    "storage_key": "property/6767906449167594/01a0101e-9569-73a0-b24d-cca99bf0f656.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "224",
  "property_year_built": "2001",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.19642857142857",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-375",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://creeksideaptskc.securecafeapplicant.com/onlineleasing/content3/access/creekside3/floorplans",
  "property_resident_portal_url": "https://creeksideaptskc.securecafe.com/residentservices/creekside3/userlogin.aspx",
  "property_apply_now_url": "https://creeksideaptskc.securecafeapplicant.com/onlineleasing/content3/access/creekside3/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-a62e-7268-a3ab-085d57eec10b.webp",
  "property_primary_logo_media": {
    "alt_text": "Creekside Apartment Homes logo",
    "public_id": "019fc974-a62e-7268-a3ab-085d57eec10b",
    "storage_key": "property/6767906449167594/019fc974-a62e-7268-a3ab-085d57eec10b.webp",
    "width": 2048,
    "height": 461
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a14031-2e95-7626-a572-198a1e186418.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Creekside Apartment Homes logo",
    "public_id": "01a14031-2e95-7626-a572-198a1e186418",
    "storage_key": "property/6767906449167594/01a14031-2e95-7626-a572-198a1e186418.webp",
    "width": 1280,
    "height": 288
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0a631-2970-723b-8314-442933ec7ed7.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a0a631-2970-723b-8314-442933ec7ed7",
    "storage_key": "property/6767906449167594/01a0a631-2970-723b-8314-442933ec7ed7.webp",
    "width": 1280,
    "height": 288
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#AD841F",
  "property_secondary_color": "#154734",
  "property_font_color": null,
  "property_color_4": "#0077C8",
  "property_color_3": "#13294B",
  "property_color_5": "#A1561C",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "658 - 1161",
  "property_sqft_min": "658",
  "property_sqft_max": "1161",
  "property_price_range": "1386 - 6953",
  "property_price_min": "1386",
  "property_price_max": "6953",
  "property_available_units": 13,
  "property_facebook_url": "https://www.facebook.com/CreeksideAptsKC",
  "property_instagram_url": "https://www.instagram.com/creeksideaptskc/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJZxlkwEqVwIcRn9rz5z0PQLA",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Creekside Apartment Homes",
  "property_home_romance_title": "Cherish Every Moment in Your New Apartment Home",
  "property_home_amenities_blurb": "<p>Stay active and unwind without leaving home. Swim in the pool, work out in the fitness center, or gather with neighbors at the picnic area and barbecue grill. Inside your one-, two-, or three-bedroom apartment, features like faux wood blinds, a breakfast bar, and upgraded cabinets add comfort to daily life. Visit our <a href=\"/amenities\">amenities page</a> to see the complete list.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to flex.</strong> Choose from one-, two-, and three-bedroom apartment homes in Overland Park, with layouts that pair practical details—fully equipped all-electric kitchens, pantries, in-home washers and dryers, spacious closets, and select private patios or balconies—with polished finishes. Select homes add vaulted ceilings, upgraded touches, or a sunroom with a built-in desk and closet for even more usable space.</p>",
  "property_home_gallery_blurb": "<p><strong>See Creekside Apartment Homes in focus.</strong> Preview bright interiors with breakfast bars, pantry-style kitchens, open ceilings, and select built-in desk sunrooms, plus private balcony or patio views that extend the space. Then picture the clubhouse lounge, billiards table, fitness area, and swimming pool set among landscaped grounds—just a glimpse of what the full gallery reveals in Overland Park.</p>",
  "property_home_neighborhood_blurb": "<p>Creekside Apartment Homes sits near 119th Street, giving residents convenient access to Johnson County Community College, Saint Luke’s South Hospital, and Oak Park Mall. Enjoy nearby recreation along the Overland Park Indian Creek Trail and at Thomas S. Stoll Park. Explore our <a href=\"/neighborhood\">neighborhood page</a> to learn more about the area.</p>",
  "property_home_reviews_blurb": "<p><strong>Resident reviews tell the Creekside story.</strong> Thoughtful service, prompt maintenance, clean apartment homes, and a calm, park-like setting come up again and again. Residents highlight caring leasing managers, smooth move-in support, nearby walking trails, and green space across the way—all adding to a community that feels easy, connected, and well cared for. Read the reviews to see why Creekside leaves such a strong impression.</p>",
  "property_neighborhood_blurb": "<p>Creekside Apartment Homes is located at 11920 Oakmont Street near 119th Street in Overland Park, KS, a short drive from Oak Park Mall for shopping and dining. Target, Walmart, and the Stoll Park Retail and Professional Center are close by for everyday errands, and a QuikTrip is nearby for gas and quick stops.</p><p>Looking for a place to eat near Creekside? Our team recommends Flapjacks ‘n More for breakfast, Unforked for a quick lunch, and K-Macho’s Mexican Grill &amp; Cantina, Aahaa Modern Indian Cuisine, or Hot Basil Thai Cuisine for dinner. Save room for dessert at Leafy Korean Dessert Cafe.</p><p>Saint Luke’s South Hospital and MISH Hospital and Clinics are near Creekside, along with Johnson County Community College and the KU Edwards Campus. Nearby public schools include Pleasant Ridge Elementary, California Trail Junior High, and Olathe East High School.</p><p>For recreation, residents can visit Quivira Park, the Stoll Off-Leash Dog Park, Sykes/Lady Overland Park Golf Course, and the Kansas City Automotive Museum.</p><p>Explore our <a href=\"/floor-plans\">floor plans</a> and <a href=\"/amenities\">amenities</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Discover amenities designed to make daily life more convenient at Creekside Apartment Homes. Enjoy a swimming pool, a fitness center, a clubhouse with a coffee bar, a business center with a printer and copy and fax services, and billiards. Covered parking is available through carports and detached garages. Our one-, two-, and three-bedroom apartments include nine-foot or vaulted ceilings, a breakfast bar, extra storage, and an in-home washer and dryer, with a sunroom available in select units.</p><h2>Overland Park Apartments With Garages</h2><p>Creekside Apartment Homes is located near 119th Street, giving residents convenient access to Johnson County Community College, Saint Luke’s South Hospital, and Oak Park Mall, with direct access to the Overland Park Indian Creek Trail. Visit our <a href=\"/neighborhood\">neighborhood page</a> to explore more of the area.</p><p>Ready to see these amenities in person? <a href=\"/schedule-a-tour\">Schedule a tour</a> of Creekside Apartment Homes today.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Creekside Apartment Homes yours?</strong><br>Choose a one-, two-, or three-bedroom apartment home with practical comforts like in-home laundry, stainless steel appliances, spacious closets, and balcony or patio options. Start your online application today and take the next step toward trail-connected Overland Park living.</p>",
  "property_contactus_blurb": "<p>Looking for more information about Creekside Apartment Homes? Our team can answer questions about available <a href=\"/floor-plans\">floor plans</a>, lease options, community and apartment <a href=\"/amenities\">amenities</a>, or <a href=\"/schedule-a-tour\">scheduling a tour</a>.</p><p>Call us, visit the leasing office at 11920 Oakmont St, Overland Park, KS 66213, or complete the contact form above. We look forward to hearing from you.</p>",
  "property_faqs_blurb": "<p>Find answers to common questions about applications, deposits, lease terms, pets, utilities, parking, and maintenance requests at Creekside Apartment Homes. You can also review our <a href=\"/floor-plans\">floor plans</a> and <a href=\"/amenities\">amenities</a> for more information.</p><p>If you do not see the answer you need, <a href=\"/contact-us\">contact Creekside Apartment Homes</a>. We are happy to help.</p>",
  "property_floorplans_blurb": "<p>Creekside Apartment Homes offers four floor plans in Overland Park, KS, from the 658-square-foot Belmont one-bedroom to the 1,161-square-foot Preakness three-bedroom.</p><p>Every Creekside floor plan includes nine-foot or vaulted ceilings, a private patio or balcony, spacious closets and pantries, a breakfast bar, and an in-home washer and dryer. Select apartments add a sunroom with a built-in desk and closet.</p><p>Compare bedroom and bathroom counts, square footage, and current pricing above. Take a closer look with a <a href=\"/virtual-tours\">floor plan video or 3D tour</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see a floor plan in person.</p>",
  "property_gallery_blurb": "<p>Browse the Creekside Apartment Homes photo gallery for a closer look at our Overland Park, KS community. View apartment interiors, including kitchens and living rooms, along with community spaces such as the pool, clubhouse, fitness center, and billiards room. After browsing, compare our <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Creekside Apartment Homes in person.</p>",
  "property_interactivemap_blurb": "<p>Use the Creekside Apartment Homes interactive property map to find available apartments by bedrooms, bathrooms, rent range, square footage, and move-in date. Select a home to see pricing and availability.</p><p>Ready to find your new home? <a href=\"/schedule-a-tour\">Schedule a tour</a> today.</p>",
  "property_pets_blurb": "<p>Creekside Apartment Homes welcomes cats and dogs, with a maximum of two pets per apartment.</p><ul><li>Monthly pet rent: $25 per pet</li><li>Non-refundable pet fee: $300 for one pet or $500 for two pets</li></ul><p>Breed restrictions apply, including Pit Bull, Rottweiler, German Shepherd, Malamute, Doberman, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and mixes of these breeds. Management may restrict additional breeds at its discretion. Exotic, feral, or wild animals are not permitted. Pet-owning residents are eligible for the <a href=\"https://www.pricebrotherskc.com/petroyaltyclub/\" target=\"_blank\">Price Brothers Pet Royalty Club</a> with payment of the pet fee.</p>",
  "property_referafriend_blurb": "<p><strong>Love life right on the trail?</strong> Share Creekside Apartment Homes with a friend. From practical apartment comforts to inviting spaces to unwind, it’s easy to pass along what makes everyday Overland Park living here feel connected, convenient, and ready for what’s next.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Creekside Apartment Homes.</strong><br>Keep everyday Overland Park living simple: pay rent, submit maintenance requests, and manage your account online. Then get back to the practical comfort of home and the trail-connected setting that makes Creekside feel easy.</p>",
  "property_reviews_blurb": "<p><strong>Hear it from Creekside residents.</strong> As you read the reviews, you’ll see a clear pattern: responsive service, well-kept apartment homes, and a setting that feels calm and connected. Residents often point to kind leasing managers, quick maintenance follow-through, and thoughtful support during move-in and everyday needs. One reviewer called Creekside the “best overall package,” highlighting its clean apartments, park-like atmosphere, and caring staff. Others love being close to the walking trail and across from green space, adding to the easygoing feel of the community. Explore the ratings and see why Creekside continues to leave such a strong impression.</p>",
  "property_created_at": "1785791250649",
  "property_scheduletour_blurb": "<p>Explore Creekside Apartment Homes in the way that works best for you. Choose a guided tour with a member of our leasing team, or take a <a href=\"/virtual-tours\">360 virtual tour</a> of select floor plans online. Our leasing office is located at 11920 Oakmont St, Overland Park, KS 66213, with tours available during business hours.</p><p>Looking for more information first? Review our <a href=\"/floor-plans\">floor plans</a> and community <a href=\"/amenities\">amenities</a> before you visit.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Creekside Apartment Homes.</strong> We’ve received your submission, and our leasing team will follow up soon. In the meantime, picture everyday Overland Park living with direct trail access, smoke-free apartment homes, and inviting spaces designed for comfort, connection, and easy unwinding.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. Creekside Apartment Homes",
  "property_seo_title_home": "Apartments in Overland Park, KS | Creekside",
  "property_seo_description_home": "Tour 1, 2 & 3-bedroom apartments at Creekside Apartment Homes in Overland Park, KS, with a pool, fitness center, and covered parking.",
  "property_seo_title_floorplans": "1, 2 & 3-Bed Apartments in Overland Park, KS",
  "property_seo_description_floorplans": "Explore 4 floor plans at Creekside Apartment Homes in Overland Park, KS, with one, two, and three-bedroom layouts and private patios.",
  "property_seo_title_amenities": "Amenities | Creekside Apartment Homes",
  "property_seo_description_amenities": "See amenities at Creekside Apartment Homes in Overland Park, KS, including a pool, fitness center, clubhouse, and pet-friendly perks.",
  "property_seo_title_gallery": "Photo Gallery | Creekside Apartment Homes",
  "property_seo_description_gallery": "Browse photos of apartment interiors, amenities, and community spaces at Creekside Apartment Homes in Overland Park, KS.",
  "property_seo_title_virtualtours": "Virtual Tours | Creekside Apartment Homes Apartments",
  "property_seo_description_virtualtours": "Discover Creekside Apartment Homes in Overland Park, KS! Take a virtual tour and imagine your future in our beautiful one to three-bedroom apartments.",
  "property_seo_title_interactivemap": "Interactive Map | Creekside Apartment Homes",
  "property_seo_description_interactivemap": "Use the Creekside Apartment Homes interactive property map to explore available apartments and floor plans in Overland Park, KS.",
  "property_seo_title_neighborhood": "Apartments Near Oak Park Mall | Creekside",
  "property_seo_description_neighborhood": "Creekside Apartment Homes sits minutes from Oak Park Mall, JCCC, and Saint Luke's South Hospital in Overland Park, KS.",
  "property_seo_title_contact": "Contact Creekside Apartment Homes | Overland Park",
  "property_seo_description_contact": "Contact Creekside Apartment Homes in Overland Park, KS to ask about floor plans, pricing, availability, or scheduling a tour.",
  "property_seo_title_faqs": "FAQs | Creekside Apartment Homes",
  "property_seo_description_faqs": "Find answers about applications, pet policies, utilities, and maintenance at Creekside Apartment Homes in Overland Park, KS.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Overland Park, KS",
  "property_seo_description_reviews": "Experience the charm of Creekside Apartment Homes! Read resident reviews and discover why Overland Park, KS, is the perfect place to call home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Overland Park, KS",
  "property_seo_description_applynow": "Discover your perfect home at Creekside Apartment Homes in Overland Park, KS. Spacious layouts, great amenities—apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Creekside Apartment Homes",
  "property_seo_description_residentaccess": "Access your Creekside Apartment Homes resident portal for easy online rent payments, maintenance requests, and community updates—all in one convenient place!",
  "property_seo_title_referafriend": "Refer A Friend | Creekside Apartment Homes",
  "property_seo_description_referafriend": "Invite friends to share the Creekside experience! Refer a buddy today and enjoy a vibrant community together in Overland Park, KS. Great neighbors await!",
  "property_seo_title_scheduletour": "Tour Creekside Apartment Homes | Overland Park",
  "property_seo_description_scheduletour": "Schedule a guided or virtual tour of Creekside Apartment Homes in Overland Park, KS, and find your next one, two, or three-bedroom home.",
  "property_seo_title_privacy": "Privacy Policy | Creekside Apartment Homes",
  "property_seo_description_privacy": "At Creekside Apartment Homes, your privacy is a priority. Discover how we safeguard your information while fostering a vibrant Overland Park community!",
  "property_seo_title_accessibility": "Website Accessibility | Creekside Apartment Homes",
  "property_seo_description_accessibility": "Experience total inclusivity at Creekside Apartment Homes in Overland Park, KS. Our commitment to accessibility ensures a welcoming home for everyone.",
  "property_seo_title_sitemap": "Sitemap | Creekside Apartment Homes",
  "property_seo_description_sitemap": "Navigate your way through Creekside Apartment Homes in Overland Park, KS. Find your perfect fit with our detailed sitemap and plan your future today!",
  "property_seo_title_thankyou": "Thank You | Creekside Apartment Homes",
  "property_seo_description_thankyou": "Thank you for reaching out to Creekside Apartment Homes in Overland Park! We're excited to connect and help you find your perfect home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Overland Park, KS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793742964445",
  "amenities": [
    {
      "id": "ec_5b0016bc96b12f0e35f6d575",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87982962",
      "title": "Business Center with 2 Computers & Printer",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-b3e0-77b9-b87f-17e9bc9c1816.webp",
      "amenity_image_media": {
        "alt_text": "Business center with computers, printers, and a lounge area.",
        "public_id": "01a0101e-b3e0-77b9-b87f-17e9bc9c1816",
        "storage_key": "property/6767906449167594/01a0101e-b3e0-77b9-b87f-17e9bc9c1816.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Business Center at Creekside Apartments in Overland Park, KS,Business Center at Creekside Apartments in Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0964acb1236548730108cf6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944631",
      "title": "Covered Parking Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-b509-776a-94a0-6e8b5fd285d7.webp",
      "amenity_image_media": {
        "alt_text": "Covered parking spaces with cars parked underneath.",
        "public_id": "01a0101e-b509-776a-94a0-6e8b5fd285d7",
        "storage_key": "property/6767906449167594/01a0101e-b509-776a-94a0-6e8b5fd285d7.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Covered parking: carports and detached garages at Creekside Apartments in Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_98b3b0e28826fa3d1ae58fc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944640",
      "title": "Shimmering Swimming Pool with Wi-Fi Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-b3e3-76bd-b7df-5b61186510e3.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style swimming pool and lounge area at dusk.",
        "public_id": "01a0101e-b3e3-76bd-b7df-5b61186510e3",
        "storage_key": "property/6767906449167594/01a0101e-b3e3-76bd-b7df-5b61186510e3.webp",
        "width": 1200,
        "height": 900
      },
      "amenity_image_alt_text": "Shimmering outdoor swimming pool at Creekside Apartments in Overland Park, KS,Shimmering outdoor swimming pool at Creekside Apartments in Overland Park, KS,Shimmering outdoor swimming pool at Creekside Apartments in Overland Park, KS,Shimmering outdoor swimming pool at Creekside Apartments in Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a6f1f7344f22a360c5961c1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944642",
      "title": "State-Of-The-Art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-b4bf-772c-9658-01dffc9d66d4.webp",
      "amenity_image_media": {
        "alt_text": "Interior view of a well-equipped fitness center with treadmills, ellipticals, and free weights.",
        "public_id": "01a0101e-b4bf-772c-9658-01dffc9d66d4",
        "storage_key": "property/6767906449167594/01a0101e-b4bf-772c-9658-01dffc9d66d4.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Spacious community gym at Creekside Apartments in Overland Park, KS,Spacious community gym at Creekside Apartments in Overland Park, KS,Spacious community gym at Creekside Apartments in Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b1fe7f727d06d354ff608cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944629",
      "title": "Clubhouse with WiFi Access & Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-b641-7009-ac67-73cc9c77e0ea.webp",
      "amenity_image_media": {
        "alt_text": "Coffee bar area with a TV and seating in the background.",
        "public_id": "01a0101e-b641-7009-ac67-73cc9c77e0ea",
        "storage_key": "property/6767906449167594/01a0101e-b641-7009-ac67-73cc9c77e0ea.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Clubhouse kitchenette at Creekside Apartments in Overland Park, KS,Clubhouse seating area with free Wi-Fi at Creekside Apartments in Overland Park, KS,Clubhouse kitchenette at Creekside Apartments in Overland Park, KS,Clubhouse kitchenette at Creekside Apartments in Overland Park, KS,Clubhouse seating area with free Wi-Fi at Creekside Apartments in Overland Park, KS,Complimentary coffee bar at Creekside Apartments in Overland Park, KS,Clubhouse seating area with free Wi-Fi at Creekside Apartments in Overland Park, KS,Clubhouse seating area with free Wi-Fi at Creekside Apartments in Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77f0f813de07925535abe036",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944627",
      "title": "Billiards",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-c603-717a-9597-936f978d6348.webp",
      "amenity_image_media": {
        "alt_text": "Community lounge area with a pool table, bar seating, and a comfortable chair.",
        "public_id": "01a0101e-c603-717a-9597-936f978d6348",
        "storage_key": "property/6767906449167594/01a0101e-c603-717a-9597-936f978d6348.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A pool table in the middle of the Clubhouse at Creekside Apartments in Overland Park, KS.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_29ebf473c6c33f982a5f82b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944638",
      "title": "Picnic Area with Barbecue",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-c658-770e-b704-a5b3eca5aed6.webp",
      "amenity_image_media": {
        "alt_text": "Picnic table and grill area in front of apartment buildings at dusk.",
        "public_id": "01a0101e-c658-770e-b704-a5b3eca5aed6",
        "storage_key": "property/6767906449167594/01a0101e-c658-770e-b704-a5b3eca5aed6.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "Community picnic table and BBQ grill at Creekside Apartments in Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8cfaf0e29eef30ebb2c6b6ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944637",
      "title": "Pet Waste Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa6813256fd0937ddb18655c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944632",
      "title": "Easy Access to Highways & Shopping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a0ef49086b73a3fe3881e224",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944639",
      "title": "Public Parks Nearby",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab46b9219907fe7217b0e5be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944641",
      "title": "Situated on The Overland Park Indian Creek Trail, with Direct Access to Trail",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f08425b761f23133bd0f434a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944625",
      "title": "Across the Street from Thomas S. Stoll Park with Off-Leash Dog Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_746fef5d73cea3ebc1906308",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944624",
      "title": "Access to Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_350a567e5f9d57fbc1d52582",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944636",
      "title": "On-Call Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c39f1b0f788de7bec3927ba6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "122755356",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_35e7584e1eb91da26fd92ae1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "122986107",
      "title": "Smoke-Free Community",
      "amount": "false",
      "description": "As of March 1st, 2025",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c1849889a567718d54228cc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944626",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-c833-70ca-8ca1-bec2f03797fc.webp",
      "amenity_image_media": {
        "alt_text": "Exterior of apartment building with brick and siding, balconies, and manicured landscaping.",
        "public_id": "01a0101e-c833-70ca-8ca1-bec2f03797fc",
        "storage_key": "property/6767906449167594/01a0101e-c833-70ca-8ca1-bec2f03797fc.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Exterior view of the beautiful landscaping outside of the apartment buildings at Creekside Apartments in Overland Park, KS,Exterior view of the beautiful landscaping outside of the clubhouse at Creekside Apartments in Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa2636f4d52ec7bf085e03a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944630",
      "title": "Copy & Fax Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_85e651f225ae2443d9e6ef28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944650",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-c767-734b-9b40-852f1d7bcf86.webp",
      "amenity_image_media": {
        "alt_text": "Empty closet with white doors and a shelf with hangers.",
        "public_id": "01a0101e-c767-734b-9b40-852f1d7bcf86",
        "storage_key": "property/6767906449167594/01a0101e-c767-734b-9b40-852f1d7bcf86.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A white door is open to a closet with clothes hangers.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e8f6374b454d8e4686b51c72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944643",
      "title": "9 Ft Ceilings Or Vaulted Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-cbcd-706c-bfc0-e25975d22411.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a sofa, coffee table, chair, and TV.",
        "public_id": "01a0101e-cbcd-706c-bfc0-e25975d22411",
        "storage_key": "property/6767906449167594/01a0101e-cbcd-706c-bfc0-e25975d22411.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "9 Ft Ceilings Or Vaulted Ceilings at Creekside Apartments, Overland Park, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ce31fddbd3086cbbd632759",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944644",
      "title": "Fully Equipped All-Electric Kitchen with Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-d4ef-7415-9d15-f943fc3dff45.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with white cabinets, white stove, and stainless steel sink.",
        "public_id": "01a0101e-d4ef-7415-9d15-f943fc3dff45",
        "storage_key": "property/6767906449167594/01a0101e-d4ef-7415-9d15-f943fc3dff45.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Apartment kitchen with all essential appliances included at Creekside Apartments in Overland Park, KS,A kitchen with a dining table and chairs.,A kitchen with white cabinets and a beige countertop.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee676f54bed5e790fe1dddaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944645",
      "title": "Balcony or Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-d7e9-70f8-8686-e54e8c8bad04.webp",
      "amenity_image_media": {
        "alt_text": "Balcony with chair, table, plants, and string lights, overlooking green trees.",
        "public_id": "01a0101e-d7e9-70f8-8686-e54e8c8bad04",
        "storage_key": "property/6767906449167594/01a0101e-d7e9-70f8-8686-e54e8c8bad04.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "A cozy balcony with a chair, a table, and a potted plant.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a7e127a63501fc605949f4b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944646",
      "title": "Breakfast Bar",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-d778-7400-be56-e245af3abf50.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen area with white cabinets, double sink, and view of living room with fireplace and striped armchair.",
        "public_id": "01a0101e-d778-7400-be56-e245af3abf50",
        "storage_key": "property/6767906449167594/01a0101e-d778-7400-be56-e245af3abf50.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Breakfast Bar at Creekside Apartments, Overland Park",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c0ee6e7f8d9744b6d2837f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944657",
      "title": "Washer and Dryer in Home",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-d847-7402-819f-aa5810db440e.webp",
      "amenity_image_media": {
        "alt_text": "In-unit washer and dryer in a closet with shelving above.",
        "public_id": "01a0101e-d847-7402-819f-aa5810db440e",
        "storage_key": "property/6767906449167594/01a0101e-d847-7402-819f-aa5810db440e.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "A small laundry room with a washer and dryer.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_70022fe98d47dc8587b07b1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944651",
      "title": "Mini Blinds",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2290ed1ef1700bdc8b6ca327",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944654",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-d968-70ed-8e58-6272b341acee.webp",
      "amenity_image_media": {
        "alt_text": "Walk-in closet with organized clothes on hangers and shelves.",
        "public_id": "01a0101e-d968-70ed-8e58-6272b341acee",
        "storage_key": "property/6767906449167594/01a0101e-d968-70ed-8e58-6272b341acee.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "A walk in closet with clothes hanging on racks.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de92a8283069485d4872f850",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "87944655",
      "title": "Sunroom with Built-In Desk and Closet*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_60742aa96c05710e8ca93809",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "122011270",
      "title": "Upgraded Cabinets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1df911af4cd39e7e9d77b337",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "122011271",
      "title": "Brushed Nickel Fixtures",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b08fcc1076f5d415f64a7d3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "external_id": "128542378",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_6e4833f0544d011c9f88df1b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-9569-73a0-b24d-cca99bf0f656.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at a multifamily property.",
        "public_id": "01a0101e-9569-73a0-b24d-cca99bf0f656",
        "storage_key": "property/6767906449167594/01a0101e-9569-73a0-b24d-cca99bf0f656.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool. Featuring comfortable lounge chairs and shaded areas, it's the perfect place to soak up the sun or enjoy a refreshing dip.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/22-11920 Oakmont St -22.jpg"
    },
    {
      "id": "ec_58e69a328a4a68949b152710",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-e9c6-705c-82c6-468c7934966d.webp",
      "image_media": {
        "alt_text": "Kitchen and living room area with white cabinets, stainless steel sink, and a sofa.",
        "public_id": "01a0101e-e9c6-705c-82c6-468c7934966d",
        "storage_key": "property/6767906449167594/01a0101e-e9c6-705c-82c6-468c7934966d.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "A spacious kitchen and living area featuring white cabinetry, a double sink, and a well-lit living space with a sofa and armchair.",
      "link": "false",
      "alt_text": "Kitchen and living room area with white cabinets, stainless steel sink, and a sofa.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-11920 Oakmont St -17.jpg"
    },
    {
      "id": "ec_0dcfd63497e03dcfc874790e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-e8ad-7409-a938-29df551fbcbc.webp",
      "image_media": {
        "alt_text": "Living room with sofa, ottoman, armchair, and door to balcony.",
        "public_id": "01a0101e-e8ad-7409-a938-29df551fbcbc",
        "storage_key": "property/6767906449167594/01a0101e-e8ad-7409-a938-29df551fbcbc.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious and well-lit living room featuring a comfortable sofa, stylish ottoman, and an accent armchair, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Living room with sofa, ottoman, armchair, and door to balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-11920 Oakmont St -13.jpg"
    },
    {
      "id": "ec_2cb335cada88e7f995d2d71c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-e74a-75bb-b94b-f25e3907ceda.webp",
      "image_media": {
        "alt_text": "Living room and dining area with TV, sofa, ottoman, and dining set.",
        "public_id": "01a0101e-e74a-75bb-b94b-f25e3907ceda",
        "storage_key": "property/6767906449167594/01a0101e-e74a-75bb-b94b-f25e3907ceda.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a mounted television, comfortable seating, and a dedicated dining space, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Living room and dining area with TV, sofa, ottoman, and dining set.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-11920 Oakmont St -15.jpg"
    },
    {
      "id": "ec_f15608b5c914f356d6947acf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-f6ac-758e-a6a6-8d886834cdbc.webp",
      "image_media": {
        "alt_text": "Dining area adjacent to kitchen with a glass-top table and four chairs.",
        "public_id": "01a0101e-f6ac-758e-a6a6-8d886834cdbc",
        "storage_key": "property/6767906449167594/01a0101e-f6ac-758e-a6a6-8d886834cdbc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious dining area featuring a glass-top table with four chairs, perfect for intimate meals. The area seamlessly connects to a well-equipped kitchen.",
      "link": "false",
      "alt_text": "Dining area adjacent to kitchen with a glass-top table and four chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-11920 Oakmont St -4.jpg"
    },
    {
      "id": "ec_481008605914b194aecfedfd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-ea2b-75fc-8ca4-0844c30d17bb.webp",
      "image_media": {
        "alt_text": "A king-sized bed with white linens and a blue throw is centered in the room, flanked by nightstands with lamps. Two framed nature prints hang above the headboard.",
        "public_id": "01a0101e-ea2b-75fc-8ca4-0844c30d17bb",
        "storage_key": "property/6767906449167594/01a0101e-ea2b-75fc-8ca4-0844c30d17bb.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Cozy and inviting, this bedroom features a comfortable king-sized bed, stylish nightstands, and calming wall art, creating a serene retreat.",
      "link": "false",
      "alt_text": "A king-sized bed with white linens and a blue throw is centered in the room, flanked by nightstands with lamps. Two framed nature prints hang above the headboard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-11920 Oakmont St -8.jpg"
    },
    {
      "id": "ec_dfad6a9e08ce5963d9d0f106",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-1543-7338-84d6-679415198f55.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, and two framed forest landscape paintings.",
        "public_id": "01a0101f-1543-7338-84d6-679415198f55",
        "storage_key": "property/6767906449167594/01a0101f-1543-7338-84d6-679415198f55.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a modern ceiling fan, and tasteful decor. An en-suite bathroom is visible through the open doorway.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, ceiling fan, and two framed forest landscape paintings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/17-11920 Oakmont St -10.jpg"
    },
    {
      "id": "ec_f39e6482ea3f348b470b95df",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-2400-71a0-82d7-ea3a7b81ed54.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen bed, nightstand, lamp, and closet.",
        "public_id": "01a0101f-2400-71a0-82d7-ea3a7b81ed54",
        "storage_key": "property/6767906449167594/01a0101f-2400-71a0-82d7-ea3a7b81ed54.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, a convenient nightstand with a lamp, and ample closet space for storage.",
      "link": "false",
      "alt_text": "Bedroom with a queen bed, nightstand, lamp, and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-11920 Oakmont St -6.jpg"
    },
    {
      "id": "ec_afb69cb7a37d00af891d0be9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-21a0-7729-bb2d-071e8a410a68.webp",
      "image_media": {
        "alt_text": "Living room with a black sofa, coffee table, and TV.",
        "public_id": "01a0101f-21a0-7729-bb2d-071e8a410a68",
        "storage_key": "property/6767906449167594/01a0101f-21a0-7729-bb2d-071e8a410a68.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable black sofa, a wooden coffee table, and a TV stand with a flat-screen TV. Large windows provide natural light.",
      "link": "false",
      "alt_text": "Living room with a black sofa, coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-11920 Oakmont St -5.jpg"
    },
    {
      "id": "ec_bb3752cc30a75a2ff2bf91dd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-28b9-74fb-b5ea-b0f7bd3bea8b.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "01a0101f-28b9-74fb-b5ea-b0f7bd3bea8b",
        "storage_key": "property/6767906449167594/01a0101f-28b9-74fb-b5ea-b0f7bd3bea8b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A bright and clean bathroom featuring a spacious vanity with ample counter space, a modern toilet, and a bathtub/shower combination.",
      "link": "false",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-11920 Oakmont St -7.jpg"
    },
    {
      "id": "ec_deb099441d123bc8f6478722",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-2595-73ac-bea5-b07c8144d0e2.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, medicine cabinet, and toilet.",
        "public_id": "01a0101f-2595-73ac-bea5-b07c8144d0e2",
        "storage_key": "property/6767906449167594/01a0101f-2595-73ac-bea5-b07c8144d0e2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a vanity with a sink, ample storage, and a bathtub with a shower.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink, medicine cabinet, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-11920 Oakmont St -2.jpg"
    },
    {
      "id": "ec_3b8639044a8f44349ecc29dd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-4d0a-752d-8749-077d5953fce5.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, black headboard, and a side table with a lamp.",
        "public_id": "01a0101f-4d0a-752d-8749-077d5953fce5",
        "storage_key": "property/6767906449167594/01a0101f-4d0a-752d-8749-077d5953fce5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-size bed with plush bedding, a black tufted headboard, and a decorative side table with a lamp and plant. The room has ample closet space and a view into the bathroom.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, black headboard, and a side table with a lamp.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-11920 Oakmont St -1.jpg"
    },
    {
      "id": "ec_27910449cca495e2f076d567",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-58a1-7581-9974-75dfa44e4b8f.webp",
      "image_media": {
        "alt_text": "Living room with black leather sofa, armchair, coffee table, and television.",
        "public_id": "01a0101f-58a1-7581-9974-75dfa44e4b8f",
        "storage_key": "property/6767906449167594/01a0101f-58a1-7581-9974-75dfa44e4b8f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a plush black leather sofa, a comfortable armchair, and a modern coffee table, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Living room with black leather sofa, armchair, coffee table, and television.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-11920 Oakmont St -3.jpg"
    },
    {
      "id": "ec_d025320fdef41cda43be2869",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-67a3-760e-a994-37b0fb24445b.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "01a0101f-67a3-760e-a994-37b0fb24445b",
        "storage_key": "property/6767906449167594/01a0101f-67a3-760e-a994-37b0fb24445b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing on a sunny day.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/21-11920 Oakmont St -21.jpg"
    },
    {
      "id": "ec_77fe8dd00eb6618b2c310ffd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-6a60-707c-9653-0f1e0887309d.webp",
      "image_media": {
        "alt_text": "An inviting outdoor swimming pool area with lounge chairs, dining sets, and lush landscaping.",
        "public_id": "01a0101f-6a60-707c-9653-0f1e0887309d",
        "storage_key": "property/6767906449167594/01a0101f-6a60-707c-9653-0f1e0887309d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge seating and outdoor dining areas. Your perfect oasis awaits.",
      "link": "false",
      "alt_text": "An inviting outdoor swimming pool area with lounge chairs, dining sets, and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/20-11920 Oakmont St -20.jpg"
    },
    {
      "id": "ec_de1547a90c9ee9ce371a2028",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-5a47-773b-89cf-3961bcb23952.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings, parking lot, and garage.",
        "public_id": "01a0101f-5a47-773b-89cf-3961bcb23952",
        "storage_key": "property/6767906449167594/01a0101f-5a47-773b-89cf-3961bcb23952.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "An aerial view showcases the apartment buildings, a well-maintained parking lot, and a convenient garage facility, all surrounded by lush greenery and trees.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings, parking lot, and garage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Residential-Building-Exterior_Parking-Lot_2026-06-09_MLS-Size.jpg"
    },
    {
      "id": "ec_f8b52d9dd9655b06206a0a56",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-6fc6-71bc-a5e5-7ef70a9b65cc.webp",
      "image_media": {
        "alt_text": "Apartment complex exterior with manicured lawns and trees.",
        "public_id": "01a0101f-6fc6-71bc-a5e5-7ef70a9b65cc",
        "storage_key": "property/6767906449167594/01a0101f-6fc6-71bc-a5e5-7ef70a9b65cc.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Beautifully maintained grounds with lush green lawns, mature trees, and well-kept buildings, creating an inviting community atmosphere.",
      "link": "false",
      "alt_text": "Apartment complex exterior with manicured lawns and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Residential-Building-Exterior_Angle-1_2026-06-09_MLS-Size.jpg"
    },
    {
      "id": "ec_b82dc1edddf9ab96a5a6db1d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-c658-770e-b704-a5b3eca5aed6.webp",
      "image_media": {
        "alt_text": "Picnic table and grill area in front of apartment buildings at dusk.",
        "public_id": "01a0101e-c658-770e-b704-a5b3eca5aed6",
        "storage_key": "property/6767906449167594/01a0101e-c658-770e-b704-a5b3eca5aed6.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Enjoy the outdoors at this community's picnic and grilling area, perfect for dining al fresco.",
      "link": "false",
      "alt_text": "Picnic table and grill area in front of apartment buildings at dusk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_BBQ-Picnic-Table_Twilight_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_548d22be5aa0e6c72353f185",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-c833-70ca-8ca1-bec2f03797fc.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with brick and siding, balconies, and manicured landscaping.",
        "public_id": "01a0101e-c833-70ca-8ca1-bec2f03797fc",
        "storage_key": "property/6767906449167594/01a0101e-c833-70ca-8ca1-bec2f03797fc.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring a blend of brick and siding, private balconies, and lush, well-maintained landscaping.",
      "link": "false",
      "alt_text": "Exterior of apartment building with brick and siding, balconies, and manicured landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Residential-Building-Exterior_Angle-2_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_dee317f8cd04fe5c2862620c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-8114-71dd-97f0-d1b7a5859261.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by trees and a golf course.",
        "public_id": "01a0101f-8114-71dd-97f0-d1b7a5859261",
        "storage_key": "property/6767906449167594/01a0101f-8114-71dd-97f0-d1b7a5859261.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing apartment buildings nestled amongst lush greenery, with a golf course visible in the distance.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings surrounded by trees and a golf course.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Drone_Neighborhood_2026-06-09_MLS-Size.jpg"
    },
    {
      "id": "ec_83bb85bb607f607f5f0a9ed7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-8349-759f-bb54-446c4e685dfa.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool surrounded by lounge chairs and lush landscaping.",
        "public_id": "01a0101f-8349-759f-bb54-446c4e685dfa",
        "storage_key": "property/6767906449167594/01a0101f-8349-759f-bb54-446c4e685dfa.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning resort-style swimming pool, perfect for relaxation and fun. Lounging chairs and beautiful greenery complete the oasis.",
      "link": "false",
      "alt_text": "Aerial view of a resort-style swimming pool surrounded by lounge chairs and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Drone_Clubhouse-Aerial-View-2_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_f1ccd83c830876dfce2bafce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-8546-767f-ab06-a32ab02c4a93.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and a resort-style pool.",
        "public_id": "01a0101f-8546-767f-ab06-a32ab02c4a93",
        "storage_key": "property/6767906449167594/01a0101f-8546-767f-ab06-a32ab02c4a93.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Experience luxury living with our stunning resort-style pool and beautiful community grounds. This aerial view showcases the amenities and architecture of the property.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings and a resort-style pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Drone_Clubhouse-Aerial-View-1_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_560b278bf207d6a31f83bd6e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-9515-76ed-89c0-db422b1093f6.webp",
      "image_media": {
        "alt_text": "Community kitchen with coffee station, sink, and microwave.",
        "public_id": "01a0101f-9515-76ed-89c0-db422b1093f6",
        "storage_key": "property/6767906449167594/01a0101f-9515-76ed-89c0-db422b1093f6.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and snacks in our well-equipped community kitchen, perfect for socializing or a quick bite.",
      "link": "false",
      "alt_text": "Community kitchen with coffee station, sink, and microwave.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Clubhouse-Kitchenette_Angle-3_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_f95a5c56640b780b1f708cd2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-97b3-75bf-b08d-1e941813dfab.webp",
      "image_media": {
        "alt_text": "Exterior of a brick multifamily property with manicured landscaping and a large green lawn.",
        "public_id": "01a0101f-97b3-75bf-b08d-1e941813dfab",
        "storage_key": "property/6767906449167594/01a0101f-97b3-75bf-b08d-1e941813dfab.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Beautifully maintained grounds surround this charming multifamily property, featuring lush green lawns, colorful flower beds, and mature trees.",
      "link": "false",
      "alt_text": "Exterior of a brick multifamily property with manicured landscaping and a large green lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Leasing-Office-Clubhouse-Exterior_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_9794d31a0b08f63b0a529865",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-98df-77dc-9f92-043636718fb2.webp",
      "image_media": {
        "alt_text": "Spacious common area with a fireplace, comfortable seating, and decorative shelving.",
        "public_id": "01a0101f-98df-77dc-9f92-043636718fb2",
        "storage_key": "property/6767906449167594/01a0101f-98df-77dc-9f92-043636718fb2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed common area, featuring a cozy fireplace, ample seating, and elegant shelving.",
      "link": "false",
      "alt_text": "Spacious common area with a fireplace, comfortable seating, and decorative shelving.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Clubhouse-Interior_Seating-Area_Angle-3_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_88a3e938c8c3652a553d6e0c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-9ae8-74f9-982a-31e08cdca0c9.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and lush greenery surrounding the clubhouse.",
        "public_id": "01a0101f-9ae8-74f9-982a-31e08cdca0c9",
        "storage_key": "property/6767906449167594/01a0101f-9ae8-74f9-982a-31e08cdca0c9.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, perfect for relaxing and soaking up the sun. Surrounded by beautiful landscaping and comfortable lounge chairs, it's your personal oasis.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and lush greenery surrounding the clubhouse.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Pool_Angle-1_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_5b27e7b03b1295c6c2898c89",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-9d2a-775c-ab31-a8f4d3ee73b2.webp",
      "image_media": {
        "alt_text": "Business center with two computer workstations and comfortable seating.",
        "public_id": "01a0101f-9d2a-775c-ab31-a8f4d3ee73b2",
        "storage_key": "property/6767906449167594/01a0101f-9d2a-775c-ab31-a8f4d3ee73b2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay connected in our modern business center, equipped with computers and high-speed internet.",
      "link": "false",
      "alt_text": "Business center with two computer workstations and comfortable seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Clubhouse-Interior_Business-Center_Angle-1_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_7c6b35d615bf38487e18b823",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-a2aa-7174-be94-b998912358fe.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, dumbbells, and treadmills.",
        "public_id": "01a0101f-a2aa-7174-be94-b998912358fe",
        "storage_key": "property/6767906449167594/01a0101f-a2aa-7174-be94-b998912358fe.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide selection of cardio equipment, free weights, and strength training machines.",
      "link": "false",
      "alt_text": "Fitness center with weight machines, dumbbells, and treadmills.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Clubhouse-Interior_Fitness-Center_Angle-3_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_b4adf19fbd619d3ff935fcb2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-b641-7009-ac67-73cc9c77e0ea.webp",
      "image_media": {
        "alt_text": "Coffee bar area with a TV and seating in the background.",
        "public_id": "01a0101e-b641-7009-ac67-73cc9c77e0ea",
        "storage_key": "property/6767906449167594/01a0101e-b641-7009-ac67-73cc9c77e0ea.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee at our stylish coffee bar, featuring a TV and comfortable seating area for residents.",
      "link": "false",
      "alt_text": "Coffee bar area with a TV and seating in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Clubhouse-Kitchenette_Angle-2_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_fa298fc59714c1b0b7d44aaf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-a766-766f-9d6b-093f95423e19.webp",
      "image_media": {
        "alt_text": "Bar area with coffee station and pool table in the background.",
        "public_id": "01a0101f-a766-766f-9d6b-093f95423e19",
        "storage_key": "property/6767906449167594/01a0101f-a766-766f-9d6b-093f95423e19.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a coffee or a game of pool in our resident lounge.",
      "link": "false",
      "alt_text": "Bar area with coffee station and pool table in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Clubhouse-Kitchenette_Angle-1_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_68ce85304bcdaa6ed773de9b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-aae5-711e-b617-a37c3062ed15.webp",
      "image_media": {
        "alt_text": "Communal lounge area with a large live-edge dining table and seating.",
        "public_id": "01a0101f-aae5-711e-b617-a37c3062ed15",
        "storage_key": "property/6767906449167594/01a0101f-aae5-711e-b617-a37c3062ed15.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed communal lounge, featuring a stunning live-edge dining table, comfortable seating areas, and a cozy fireplace.",
      "link": "false",
      "alt_text": "Communal lounge area with a large live-edge dining table and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Clubhouse-Interior_Seating-Area_Angle-2_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_85f63f7026d643e9175f070e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-acb4-729d-886e-91dd4ce7ad3d.webp",
      "image_media": {
        "alt_text": "Coffee bar with Keurig machine, assorted syrups, and coffee mate.",
        "public_id": "01a0101f-acb4-729d-886e-91dd4ce7ad3d",
        "storage_key": "property/6767906449167594/01a0101f-acb4-729d-886e-91dd4ce7ad3d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a fresh cup of coffee at our resident coffee bar, fully stocked with Keurig, syrups, and creamers.",
      "link": "false",
      "alt_text": "Coffee bar with Keurig machine, assorted syrups, and coffee mate.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Clubhouse-Kitchenette_Coffee-Bar_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_afa902335734d452bd3ab37f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-ab98-77a4-bdf5-233ab1b4a055.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, and weight machines.",
        "public_id": "01a0101f-ab98-77a4-bdf5-233ab1b4a055",
        "storage_key": "property/6767906449167594/01a0101f-ab98-77a4-bdf5-233ab1b4a055.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with modern cardio and strength training equipment for a complete workout.",
      "link": "false",
      "alt_text": "Gym with treadmills, ellipticals, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Clubhouse-Interior_Fitness-Center_Angle-2_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_001074a368868f82ad070f53",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-d7e9-70f8-8686-e54e8c8bad04.webp",
      "image_media": {
        "alt_text": "Balcony with chair, table, plants, and string lights, overlooking green trees.",
        "public_id": "01a0101e-d7e9-70f8-8686-e54e8c8bad04",
        "storage_key": "property/6767906449167594/01a0101e-d7e9-70f8-8686-e54e8c8bad04.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony, complete with stylish seating, lush plants, and ambient string lights.",
      "link": "false",
      "alt_text": "Balcony with chair, table, plants, and string lights, overlooking green trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Staged-Patio_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_6678a6fd11bf5b64c2d92cbb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-b114-72d8-abc4-2f91d4a42700.webp",
      "image_media": {
        "alt_text": "Dining area with a long wooden table and chairs.",
        "public_id": "01a0101f-b114-72d8-abc4-2f91d4a42700",
        "storage_key": "property/6767906449167594/01a0101f-b114-72d8-abc4-2f91d4a42700.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Stylish dining area featuring a large wooden table surrounded by elegant chairs, perfect for shared meals.",
      "link": "false",
      "alt_text": "Dining area with a long wooden table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Clubhouse-Interior_Seating-Area_Angle-1_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_4b4d2529b44ee4c5e8a8f5dc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-b4bf-772c-9658-01dffc9d66d4.webp",
      "image_media": {
        "alt_text": "Interior view of a well-equipped fitness center with treadmills, ellipticals, and free weights.",
        "public_id": "01a0101e-b4bf-772c-9658-01dffc9d66d4",
        "storage_key": "property/6767906449167594/01a0101e-b4bf-772c-9658-01dffc9d66d4.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment, weight machines, and free weights for a complete workout.",
      "link": "false",
      "alt_text": "Interior view of a well-equipped fitness center with treadmills, ellipticals, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Clubhouse-Interior_Fitness-Center_Angle-1_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_c53a4baeededb910e2cc6c28",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-b3e0-77b9-b87f-17e9bc9c1816.webp",
      "image_media": {
        "alt_text": "Business center with computers, printers, and a lounge area.",
        "public_id": "01a0101e-b3e0-77b9-b87f-17e9bc9c1816",
        "storage_key": "property/6767906449167594/01a0101e-b3e0-77b9-b87f-17e9bc9c1816.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay connected and productive in our resident business center, featuring computers, printing services, and comfortable seating.",
      "link": "false",
      "alt_text": "Business center with computers, printers, and a lounge area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Clubhouse-Interior_Business-Center_Angle-2_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_e5a06ffc812051c63b9b969c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-d968-70ed-8e58-6272b341acee.webp",
      "image_media": {
        "alt_text": "Walk-in closet with organized clothes on hangers and shelves.",
        "public_id": "01a0101e-d968-70ed-8e58-6272b341acee",
        "storage_key": "property/6767906449167594/01a0101e-d968-70ed-8e58-6272b341acee.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and hanging space, perfect for organizing your wardrobe.",
      "link": "false",
      "alt_text": "Walk-in closet with organized clothes on hangers and shelves.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Apartment-Interior_Walk-in-Closet_2026-06-09_MLS-Size(1).jpg"
    },
    {
      "id": "ec_dd3c6dd3b77556d1817e7b25",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-d4ef-7415-9d15-f943fc3dff45.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, white stove, and stainless steel sink.",
        "public_id": "01a0101e-d4ef-7415-9d15-f943fc3dff45",
        "storage_key": "property/6767906449167594/01a0101e-d4ef-7415-9d15-f943fc3dff45.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen featuring white cabinetry, a white electric stove, and a double-basin stainless steel sink. Ample counter space and a neutral color palette make this kitchen inviting.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, white stove, and stainless steel sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-11920 Oakmont St -19(1).jpg"
    },
    {
      "id": "ec_8a037d1e2b21608b6844c032",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101e-c603-717a-9597-936f978d6348.webp",
      "image_media": {
        "alt_text": "Community lounge area with a pool table, bar seating, and a comfortable chair.",
        "public_id": "01a0101e-c603-717a-9597-936f978d6348",
        "storage_key": "property/6767906449167594/01a0101e-c603-717a-9597-936f978d6348.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy leisure time in our community lounge, complete with a pool table, bar area, and cozy seating.",
      "link": "false",
      "alt_text": "Community lounge area with a pool table, bar seating, and a comfortable chair.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Creekside-008_Photo_Clubhouse-Interior_Pool-Table_2026-06-09_MLS-Size(2).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_c5642caa-ebec-4868-ac76-65590310f5f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Talk of the Town Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "11922 W 119th St, Overland Park, KS 66213, USA",
      "poi_short_description": "Wide-ranging American menu & sizable microbrew selection offered in a casual sports-bar setting.",
      "poi_long_description": "Wide-ranging American menu & sizable microbrew selection offered in a casual sports-bar setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-6f5d-727e-b55b-762b60d50bfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-6f5d-727e-b55b-762b60d50bfb",
        "storage_key": "property/6767906449167594/019fc977-6f5d-727e-b55b-762b60d50bfb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.talkofthetowngrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11519808852011712913&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "talk-of-the-town-grill--bar",
      "poi_latitude": "38.9134106",
      "poi_longitude": "-94.7252605",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 913-661-9922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4319-757b-b1a6-48a3fd13fc11",
        "storage_key": "property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX1JPRbTqwIcRkQGPyB2V3p8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_54c38276-8db6-47fb-bfec-49f5c0df4867",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Hot Basil Thai Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "7528 W 119th St, Overland Park, KS 66213, USA",
      "poi_short_description": "Varied Thai dishes served with beer & wine in a tranquil shopping-plaza storefront with a patio.",
      "poi_long_description": "Varied Thai dishes served with beer & wine in a tranquil shopping-plaza storefront with a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019ff6c3-3f8f-737a-bc81-bcd04526ef73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-3f8f-737a-bc81-bcd04526ef73",
        "storage_key": "property/6767906449167594/019ff6c3-3f8f-737a-bc81-bcd04526ef73.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hotbasilks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16796460448027890106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hot-basil-thai-cuisine",
      "poi_latitude": "38.9139158",
      "poi_longitude": "-94.6731231",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-451-3713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4319-757b-b1a6-48a3fd13fc11",
        "storage_key": "property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmWwqn2nqwIcRutGZOMkDGek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_b9f1968f-b989-46d5-aa1c-a34c117375d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Kolaches And Coffee",
      "poi_type": "Restaurants",
      "poi_address": "7214 W 119th St, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-cdb9-77dd-83c4-ca99454fe117.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-cdb9-77dd-83c4-ca99454fe117",
        "storage_key": "property/6767906449167594/01a0101a-cdb9-77dd-83c4-ca99454fe117.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.kolachesandcoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3180400098020501414&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kolaches-and-coffee",
      "poi_latitude": "38.9158294",
      "poi_longitude": "-94.6715332",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-343-4410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-b885-7548-b899-cde29a1ebfa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc977-b885-7548-b899-cde29a1ebfa0",
        "storage_key": "property/6767906449167594/019fc977-b885-7548-b899-cde29a1ebfa0.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ62JOqJvrwIcRpich5gkNIyw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_304bf2e4-6ff8-45a5-9796-810d5dac7d43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Barley's Kitchen + Tap",
      "poi_type": "Restaurants",
      "poi_address": "11924 W 119th St, Overland Park, KS 66213, USA",
      "poi_short_description": "Brewpub offering a full-length upscale American comfort-food menu, global beer list & TV-watching.",
      "poi_long_description": "Brewpub offering a full-length upscale American comfort-food menu, global beer list & TV-watching.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-6e51-77eb-91d5-f199862bc9db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-6e51-77eb-91d5-f199862bc9db",
        "storage_key": "property/6767906449167594/019fc977-6e51-77eb-91d5-f199862bc9db.webp",
        "width": 999,
        "height": 888
      },
      "poi_business_url": "http://barleyskitchenandtap.com/op/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7369584364347950482&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barleys-kitchen--tap",
      "poi_latitude": "38.9133583",
      "poi_longitude": "-94.7257415",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 913-663-4099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4319-757b-b1a6-48a3fd13fc11",
        "storage_key": "property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr63MWrTqwIcRkoU7A-8FRmY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ea0bc991-708a-464e-97f8-79be63d3bf6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "JOY WOK Super Buffet - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "12631 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "A full Chinese menu & an all-you-can-eat weekend buffet in a contemporary setting.",
      "poi_long_description": "A full Chinese menu & an all-you-can-eat weekend buffet in a contemporary setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-15af-71a9-bfe2-6ce9c4a16962.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc974-15af-71a9-bfe2-6ce9c4a16962",
        "storage_key": "property/6767906449167594/019fc974-15af-71a9-bfe2-6ce9c4a16962.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://joywokkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17484000350355608509&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joy-wok-super-buffet---overland-park",
      "poi_latitude": "38.8996552",
      "poi_longitude": "-94.6661065",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-498-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4319-757b-b1a6-48a3fd13fc11",
        "storage_key": "property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSeYVdmvqwIcRvVPAN6-lo_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_a1a0dfc3-08f0-4e05-9c33-0b244d6507bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Red Door Woodfired Grill",
      "poi_type": "Restaurants",
      "poi_address": "11851 Roe Ave, Leawood, KS 66211, USA",
      "poi_short_description": "This casual American eatery with a brick patio offers foods cooked on a wood-fired grill.",
      "poi_long_description": "This casual American eatery with a brick patio offers foods cooked on a wood-fired grill.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-76e7-7655-ad8c-45fe21b7d20e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-76e7-7655-ad8c-45fe21b7d20e",
        "storage_key": "property/6767906449167594/019fc977-76e7-7655-ad8c-45fe21b7d20e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://reddoorgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18358751246709491710&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-door-woodfired-grill",
      "poi_latitude": "38.9139376",
      "poi_longitude": "-94.6376498",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-227-4959",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4319-757b-b1a6-48a3fd13fc11",
        "storage_key": "property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV6WDqfPpwIcR_gfhc_1ix_4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_73b648ad-8373-4950-a81a-470dc3f4f936",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Louie's Wine Dive and Kitchen 119",
      "poi_type": "Restaurants",
      "poi_address": "6701 W 119th St, Overland Park, KS 66209, USA",
      "poi_short_description": "Comfortable destination known for locally sourced comfort food & an extensive wine list.",
      "poi_long_description": "Comfortable destination known for locally sourced comfort food & an extensive wine list.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019ff6c3-3a3b-70c5-b142-34aa527ab7da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-3a3b-70c5-b142-34aa527ab7da",
        "storage_key": "property/6767906449167594/019ff6c3-3a3b-70c5-b142-34aa527ab7da.webp",
        "width": 1024,
        "height": 682
      },
      "poi_business_url": "https://www.louieswinedive.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17363784540288348534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "louies-wine-dive-and-kitchen-119",
      "poi_latitude": "38.9123445",
      "poi_longitude": "-94.6636772",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-469-4177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019ff6c3-6960-755c-91fd-f0570d6f8f62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6c3-6960-755c-91fd-f0570d6f8f62",
        "storage_key": "property/6767906449167594/019ff6c3-6960-755c-91fd-f0570d6f8f62.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGUqh8BTqwIcRdnFOyAqO-PA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "custom_4db21736-7d44-4d38-ae1e-ccf014adba06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Gert's Grille",
      "poi_type": "Restaurants",
      "poi_address": "12018 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Comfy sports-centric hub in a strip mall serving sandwiches & soups along with draft beers.",
      "poi_long_description": "Comfy sports-centric hub in a strip mall serving sandwiches & soups along with draft beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-cd92-746b-868d-0ea80baa3c66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-cd92-746b-868d-0ea80baa3c66",
        "storage_key": "property/6767906449167594/01a0101a-cd92-746b-868d-0ea80baa3c66.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.gertsgrille.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8156820664344493126&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gerts-grille",
      "poi_latitude": "38.9285803",
      "poi_longitude": "-94.7268838",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-469-5505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4319-757b-b1a6-48a3fd13fc11",
        "storage_key": "property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoZUxn9PqwIcRRrzRci3ZMnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3b5d0d83-62ae-4249-af4e-465083667540",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "The Peanut",
      "poi_type": "Restaurants",
      "poi_address": "12663 Metcalf Ave, Overland Park, KS 66209, USA",
      "poi_short_description": "Sports bar & grill with classic American pub grub such as BLTs & spicy wings as well as drinks.",
      "poi_long_description": "Sports bar & grill with classic American pub grub such as BLTs & spicy wings as well as drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019ff6c3-3ed4-738c-b823-114ee5124129.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-3ed4-738c-b823-114ee5124129",
        "storage_key": "property/6767906449167594/019ff6c3-3ed4-738c-b823-114ee5124129.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://peanutmidwest.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2276153363687956292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-peanut",
      "poi_latitude": "38.8990944",
      "poi_longitude": "-94.6662929",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-491-0288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4319-757b-b1a6-48a3fd13fc11",
        "storage_key": "property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL8knm3TqwIcRRF_uuGyFlh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_c8b18620-8a5e-4dea-968b-4f83918b7150",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "5901 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Family-friendly venue with pickleball courts and other games, plus a casual restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-7df8-7399-ac34-f6189a16fd8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-7df8-7399-ac34-f6189a16fd8b",
        "storage_key": "property/6767906449167594/019fc977-7df8-7399-ac34-f6189a16fd8b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickennpickle.com/location/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3904135511973972812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chicken-n-pickle---overland-park",
      "poi_latitude": "38.8830518",
      "poi_longitude": "-94.6552102",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-703-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4319-757b-b1a6-48a3fd13fc11",
        "storage_key": "property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9D8rijBwIcRTEsyKpBGLjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_cdceeb12-90e5-428d-a130-1399b06f078e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Grimaldi's Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "5601 W 135th St Suite 2240, Overland Park, KS 66224, USA",
      "poi_short_description": "Casual, Brooklyn-based pizzeria chain serving brick-oven pies & calzones, plus wine & beer.",
      "poi_long_description": "Casual, Brooklyn-based pizzeria chain serving brick-oven pies & calzones, plus wine & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019ff6c3-3e85-7638-8d13-5432cc05ad19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-3e85-7638-8d13-5432cc05ad19",
        "storage_key": "property/6767906449167594/019ff6c3-3e85-7638-8d13-5432cc05ad19.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.grimaldispizzeria.com/locations/prairiefire/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11892796518695667969&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grimaldis-pizzeria",
      "poi_latitude": "38.8832213",
      "poi_longitude": "-94.650748",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-851-5062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4319-757b-b1a6-48a3fd13fc11",
        "storage_key": "property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3bEPxvDBwIcRAYnbSmyzC6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_d4b7c82c-a001-4f50-a44f-9f9b592f9aba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Strang Hall",
      "poi_type": "Restaurants",
      "poi_address": "7313 W 80th St, Overland Park, KS 66204, USA",
      "poi_short_description": "Industrial-chic food court with diverse eateries & outdoor tables on a grassy lawn.",
      "poi_long_description": "Industrial-chic food court with diverse eateries & outdoor tables on a grassy lawn.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019ff6c3-3a9e-76a7-ad1a-cc17f41f94e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-3a9e-76a7-ad1a-cc17f41f94e0",
        "storage_key": "property/6767906449167594/019ff6c3-3a9e-76a7-ad1a-cc17f41f94e0.webp",
        "width": 1215,
        "height": 911
      },
      "poi_business_url": "https://www.stranghall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1763956639910195457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "strang-hall",
      "poi_latitude": "38.983876",
      "poi_longitude": "-94.6706021",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-701-7041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4319-757b-b1a6-48a3fd13fc11",
        "storage_key": "property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2WgU63twIcRAfEJ2TfVehg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_be095935-9a44-4311-8f5c-010571d72cc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "J. Gilbert's Wood-Fired Steaks & Seafood",
      "poi_type": "Restaurants",
      "poi_address": "8901 Metcalf Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "Fine-dining-style establishment offering classic steakhouse fare, cocktails & a big menu of sides.",
      "poi_long_description": "Fine-dining-style establishment offering classic steakhouse fare, cocktails & a big menu of sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-cdf4-7335-86f7-973938bbb587.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-cdf4-7335-86f7-973938bbb587",
        "storage_key": "property/6767906449167594/01a0101a-cdf4-7335-86f7-973938bbb587.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jgilberts.com/location/jgilberts-kansas-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15434298553447221834&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "j-gilberts-wood-fired-steaks--seafood",
      "poi_latitude": "38.96726",
      "poi_longitude": "-94.66683",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-642-8070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4319-757b-b1a6-48a3fd13fc11",
        "storage_key": "property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWwakY43rwIcRSgqMi8KkMdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_9a8366c6-b416-4fb9-b8cd-62b910553c49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "First Watch",
      "poi_type": "Restaurants",
      "poi_address": "9102 Metcalf Ave Ste a, Overland Park, KS 66212, USA",
      "poi_short_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_long_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-d06c-779a-a406-7c4b35ade6e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-d06c-779a-a406-7c4b35ade6e6",
        "storage_key": "property/6767906449167594/01a0101a-d06c-779a-a406-7c4b35ade6e6.webp",
        "width": 1280,
        "height": 528
      },
      "poi_business_url": "https://www.firstwatch.com/locations/metcalf/?utm_source=gbp-listing&utm_medium=organic&utm_campaign=gbp-listing&utm_content=metcalf",
      "poi_directions_map_url": "https://maps.google.com/?cid=6698968312222769508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-watch",
      "poi_latitude": "38.9631843",
      "poi_longitude": "-94.6681656",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-871-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4319-757b-b1a6-48a3fd13fc11",
        "storage_key": "property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo3GwG77rwIcRZOGi8y-E91w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_50a1cde7-0724-4db3-9488-1e12ff620c00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "The Upper Crust",
      "poi_type": "Restaurants",
      "poi_address": "7943 Santa Fe Dr, Overland Park, KS 66204, USA",
      "poi_short_description": "Bakery, pie shop and cookie shop serving pies by the whole and by the slice, plus ice cream and quiches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-d178-751c-bc16-c3d652552ec2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-d178-751c-bc16-c3d652552ec2",
        "storage_key": "property/6767906449167594/01a0101a-d178-751c-bc16-c3d652552ec2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.uppercrustpiebakery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6949648004903446457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-upper-crust",
      "poi_latitude": "38.9843595",
      "poi_longitude": "-94.6715974",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-642-2999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4319-757b-b1a6-48a3fd13fc11",
        "storage_key": "property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXQCBcHHswIcRuadFJgoccmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_8f21f8b8-c775-4e64-b61c-a06a2f3e39b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "QuikTrip",
      "poi_type": "Transportation & Transit",
      "poi_address": "11902 Riley St, Overland Park, KS 66213, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-8373-71db-ab44-d48e9ed6a1b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-8373-71db-ab44-d48e9ed6a1b6",
        "storage_key": "property/6767906449167594/019fc977-8373-71db-ab44-d48e9ed6a1b6.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/ks/overland-park/11902-riley-st?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDQyNTMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5090252718221405687&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "38.9122348",
      "poi_longitude": "-94.6730365",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-469-1836",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-b881-7280-89bd-00900760e6cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc977-b881-7280-89bd-00900760e6cc",
        "storage_key": "property/6767906449167594/019fc977-b881-7280-89bd-00900760e6cc.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJDcpceqjBwIcR962NvuA1pEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_efc8929d-f2f9-4ea5-8d78-2d0142a53de8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "888 INT'L MARKET & CAFE",
      "poi_type": "Restaurants",
      "poi_address": "10118 W 119th St, Overland Park, KS 66213, USA",
      "poi_short_description": "Grocer featuring Asian and other international pantry staples, plus cookware, and a restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-7dde-75f8-9d48-064a0253fc5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-7dde-75f8-9d48-064a0253fc5a",
        "storage_key": "property/6767906449167594/019fc977-7dde-75f8-9d48-064a0253fc5a.webp",
        "width": 1065,
        "height": 1280
      },
      "poi_business_url": "https://www.888bakeryandcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12102760883395734594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "888-intl-market--cafe",
      "poi_latitude": "38.9148753",
      "poi_longitude": "-94.702473",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-341-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4319-757b-b1a6-48a3fd13fc11",
        "storage_key": "property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_dfWevqwIcRQqxLeOak9ac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3e85fae0-2afd-49fa-9345-ce157e32bbd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "TT Asian Grocery",
      "poi_type": "Shopping & Retail",
      "poi_address": "10138 W 119th St, Overland Park, KS 66210, USA",
      "poi_short_description": "Market for staples from India and Sri Lanka, as well as frozen goods and spices.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-cebd-7177-a747-e97d96a9c80f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-cebd-7177-a747-e97d96a9c80f",
        "storage_key": "property/6767906449167594/01a0101a-cebd-7177-a747-e97d96a9c80f.webp",
        "width": 1280,
        "height": 740
      },
      "poi_business_url": "https://www.pointy.com/shops/usa/kansas/overland-park/tt-asian-grocery",
      "poi_directions_map_url": "https://maps.google.com/?cid=10190309959878334000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tt-asian-grocery",
      "poi_latitude": "38.914077",
      "poi_longitude": "-94.702556",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-766-4960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-431a-772b-a9c5-fd3fafea30f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-431a-772b-a9c5-fd3fafea30f1",
        "storage_key": "property/6767906449167594/019fc974-431a-772b-a9c5-fd3fafea30f1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ46ZUTevqwIcRMFas_epAa40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_747756ab-f3b2-4181-bc2b-95a76c845a26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Pan-Asia Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "12035 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-1ab8-70d0-b1b8-6662ac058498.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc974-1ab8-70d0-b1b8-6662ac058498",
        "storage_key": "property/6767906449167594/019fc974-1ab8-70d0-b1b8-6662ac058498.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.panasiasupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9528951617222594223&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pan-asia-supermarket",
      "poi_latitude": "38.9117453",
      "poi_longitude": "-94.6651375",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-345-9001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-431a-772b-a9c5-fd3fafea30f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-431a-772b-a9c5-fd3fafea30f1",
        "storage_key": "property/6767906449167594/019fc974-431a-772b-a9c5-fd3fafea30f1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDfWmwWvqwIcRr85vYgKjPYQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_dfca9418-e317-4e79-b27e-90161bc99344",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "12200 Blue Valley Pkwy, Overland Park, KS 66213, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019ff6c3-445a-70b0-8b68-e7afba3bc195.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-445a-70b0-8b68-e7afba3bc195",
        "storage_key": "property/6767906449167594/019ff6c3-445a-70b0-8b68-e7afba3bc195.webp",
        "width": 1280,
        "height": 669
      },
      "poi_business_url": "https://www.target.com/sl/overland-park/1757",
      "poi_directions_map_url": "https://maps.google.com/?cid=6931391453674116315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "38.9076847",
      "poi_longitude": "-94.6750703",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-327-7770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4340-710a-9b75-0d66d6fa8a10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4340-710a-9b75-0d66d6fa8a10",
        "storage_key": "property/6767906449167594/019fc974-4340-710a-9b75-0d66d6fa8a10.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJk4-I6W7qwIcR25Rsk80_MWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_4cbaf5d6-6acf-4f92-b1ca-373ed87b158e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "12691 Antioch Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019ff6c3-51ed-768f-8ea0-f9e0bbdf214b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-51ed-768f-8ea0-f9e0bbdf214b",
        "storage_key": "property/6767906449167594/019ff6c3-51ed-768f-8ea0-f9e0bbdf214b.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/overland-park-ks-pharmacies/12691-antioch-overland-park-ks-66213/storeid=8585?WT.mc_id=LS_GOOGLE_RX_8585",
      "poi_directions_map_url": "https://maps.google.com/?cid=8009062976100597061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.8989109",
      "poi_longitude": "-94.6848773",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-681-9665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-b89b-7501-b03b-eb2ba1eb4634.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc977-b89b-7501-b03b-eb2ba1eb4634",
        "storage_key": "property/6767906449167594/019fc977-b89b-7501-b03b-eb2ba1eb4634.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV8dKcX7qwIcRRX01ylfoJW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_062e2829-ec4b-4729-b6ec-c66788e99926",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Oak Park Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "11149 W 95th St, Overland Park, KS 66214, USA",
      "poi_short_description": "Busy, long-standing indoor shopping destination with 2 levels of popular brands & a food court.",
      "poi_long_description": "Busy, long-standing indoor shopping destination with 2 levels of popular brands & a food court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019ff6bf-d7c3-73ef-ab0b-fcaf5aefc3ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bf-d7c3-73ef-ab0b-fcaf5aefc3ae",
        "storage_key": "property/6767906449167594/019ff6bf-d7c3-73ef-ab0b-fcaf5aefc3ae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.shopoakparkmall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3751688215534709327&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall",
      "poi_latitude": "38.9530939",
      "poi_longitude": "-94.7196254",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-888-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4340-710a-9b75-0d66d6fa8a10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4340-710a-9b75-0d66d6fa8a10",
        "storage_key": "property/6767906449167594/019fc974-4340-710a-9b75-0d66d6fa8a10.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzVbG9zXrwIcRTyr3Ao6sEDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_2d34e374-221e-48aa-b93a-130c616825c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "11525 Metcalf Ave Rm 277, Overland Park, KS 66210, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-8483-71ee-941e-7b70d773aa6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-8483-71ee-941e-7b70d773aa6c",
        "storage_key": "property/6767906449167594/019fc977-8483-71ee-941e-7b70d773aa6c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.bestbuy.com/ks/overland-park/11525-metcalf-ave-277.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=1347457031624297087&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "38.916929",
      "poi_longitude": "-94.66683",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-663-1291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4340-710a-9b75-0d66d6fa8a10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4340-710a-9b75-0d66d6fa8a10",
        "storage_key": "property/6767906449167594/019fc974-4340-710a-9b75-0d66d6fa8a10.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJF2eAWUDqwIcRf4oR-AchsxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_3929dac0-377f-4e84-bf03-014fa65fdb8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Pleasant Ridge Elementary School",
      "poi_type": "Education",
      "poi_address": "12235 Rosehill St, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-8879-77d8-82cd-b03aa78495ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-8879-77d8-82cd-b03aa78495ef",
        "storage_key": "property/6767906449167594/019fc977-8879-77d8-82cd-b03aa78495ef.webp",
        "width": 1280,
        "height": 730
      },
      "poi_business_url": "http://www.olatheschools.org/pleasantridge",
      "poi_directions_map_url": "https://maps.google.com/?cid=11267647678519589529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pleasant-ridge-elementary-school",
      "poi_latitude": "38.9072187",
      "poi_longitude": "-94.7345938",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-780-7590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4347-76ac-ab62-ff5df0fce583",
        "storage_key": "property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKcvLyU6VwIcRmTpqdN25Xpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_46e50651-6851-4f13-8ba5-cced63dee299",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Bentwood Elementary School",
      "poi_type": "Education",
      "poi_address": "13000 Bond St, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.olatheschools.org/bentwood/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5490286288728705891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bentwood-elementary-school",
      "poi_latitude": "38.8911317",
      "poi_longitude": "-94.7220723",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-780-7320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4347-76ac-ab62-ff5df0fce583",
        "storage_key": "property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAcXPZXHBwIcRY0vfckpqMUw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_1a29fad7-e13a-4406-8797-40522f4d75b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Oak Hill Elementary School",
      "poi_type": "Education",
      "poi_address": "10200 W 124th St, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019ff6c3-496e-7067-9f4f-0a02b614a232.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-496e-7067-9f4f-0a02b614a232",
        "storage_key": "property/6767906449167594/019ff6c3-496e-7067-9f4f-0a02b614a232.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bluevalleyk12.org/ohe",
      "poi_directions_map_url": "https://maps.google.com/?cid=17964561602799488151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-hill-elementary-school",
      "poi_latitude": "38.9046265",
      "poi_longitude": "-94.7042929",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-239-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4347-76ac-ab62-ff5df0fce583",
        "storage_key": "property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI_YQc5fqwIcRl0x88JjxTvk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_571ac748-d258-4879-9d71-845fa297ecdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "California Trail Middle School",
      "poi_type": "Education",
      "poi_address": "13775 W 133rd St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.olatheschools.org/californiatrail/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4023738896053685227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "california-trail-middle-school",
      "poi_latitude": "38.8860707",
      "poi_longitude": "-94.7466726",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-780-7220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4347-76ac-ab62-ff5df0fce583",
        "storage_key": "property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBZgmSP6_wIcR68szEDUx1zc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6b87b621-a4a1-48c4-b7d0-69c21ba866a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Olathe East High School",
      "poi_type": "Education",
      "poi_address": "14545 W 127th St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-8b23-7208-996b-19a955c27249.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-8b23-7208-996b-19a955c27249",
        "storage_key": "property/6767906449167594/019fc977-8b23-7208-996b-19a955c27249.webp",
        "width": 1280,
        "height": 590
      },
      "poi_business_url": "http://www.olatheschools.org/east/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4226639083448974343&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-east-high-school",
      "poi_latitude": "38.8956297",
      "poi_longitude": "-94.7538396",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-780-7120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4347-76ac-ab62-ff5df0fce583",
        "storage_key": "property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg4KXUWGVwIcRBzzCStoJqDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_431208b3-73ff-4e05-93a3-f72a550b80d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "The Goddard School of Overland Park",
      "poi_type": "Education",
      "poi_address": "11060 Oakmont St, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-84db-76cf-bdb1-cd0e10516612.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-84db-76cf-bdb1-cd0e10516612",
        "storage_key": "property/6767906449167594/019fc977-84db-76cf-bdb1-cd0e10516612.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://www.goddardschool.com/schools/ks/overland-park/overland-park?utm_source=google&utm_medium=business_listings&utm_campaign=school&utm_content=main_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=16130861848119914181&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-goddard-school-of-overland-park",
      "poi_latitude": "38.928519",
      "poi_longitude": "-94.730134",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-451-1066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4347-76ac-ab62-ff5df0fce583",
        "storage_key": "property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGTeRgSyVwIcRxa4WymJV3N8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_ccc059f2-be63-44c7-9c33-4b2d499ad4fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Sonshine Preschool",
      "poi_type": "Education",
      "poi_address": "14498 166th St, Bonner Springs, KS 66012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-d4ba-71fd-b58e-f1a577912744.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-d4ba-71fd-b58e-f1a577912744",
        "storage_key": "property/6767906449167594/01a0101a-d4ba-71fd-b58e-f1a577912744.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sonshinepreschoolbasehor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5928983523833614902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sonshine-preschool",
      "poi_latitude": "39.0389603",
      "poi_longitude": "-94.9640285",
      "poi_miles_from_property": "21.7",
      "poi_walking_minutes": "7 hours 57 mins",
      "poi_biking_minutes": "2 hours 6 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 913-206-5807",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4347-76ac-ab62-ff5df0fce583",
        "storage_key": "property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO9kbg0-bwIcRNhI_ERr7R1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_4a06338b-71ac-4e9e-95f4-413f5aa0f481",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Switzer Commons KinderCare",
      "poi_type": "Education",
      "poi_address": "13445 Switzer Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-8883-753f-9a90-7bd2196fd69a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-8883-753f-9a90-7bd2196fd69a",
        "storage_key": "property/6767906449167594/019fc977-8883-753f-9a90-7bd2196fd69a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/overland-park/ks/301657?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_NTA4MDIzLTcxNS1sb2NhdGlvbi5nb29nbGVfd2Vic2l0ZV9vdmVycmlkZQ==",
      "poi_directions_map_url": "https://maps.google.com/?cid=18198968816019496727&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "switzer-commons-kindercare",
      "poi_latitude": "38.8854701",
      "poi_longitude": "-94.6996606",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-814-8509",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4347-76ac-ab62-ff5df0fce583",
        "storage_key": "property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyZlfjjzAwIcRF99ARbe5j_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_189bf8cd-88ee-4011-bcd7-992bf3a758fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-1bdb-7341-a7cc-3224947bc4a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc974-1bdb-7341-a7cc-3224947bc4a4",
        "storage_key": "property/6767906449167594/019fc974-1bdb-7341-a7cc-3224947bc4a4.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4347-76ac-ab62-ff5df0fce583",
        "storage_key": "property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b7c0f3bf-3e76-4c86-b16b-0b5d0506f2af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Cleveland University-Kansas City",
      "poi_type": "Education",
      "poi_address": "10850 Lowell Ave, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-d63c-706e-8e78-cbdd9ef56c03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-d63c-706e-8e78-cbdd9ef56c03",
        "storage_key": "property/6767906449167594/01a0101a-d63c-706e-8e78-cbdd9ef56c03.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://www.cleveland.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7325880582172318479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cleveland-university-kansas-city",
      "poi_latitude": "38.9320301",
      "poi_longitude": "-94.6791964",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-234-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4347-76ac-ab62-ff5df0fce583",
        "storage_key": "property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu7zvtFPqwIcRDxtQR5PBqmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_63b57da8-b331-4f70-af74-de712fc758b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Museum at Prairiefire",
      "poi_type": "Entertainment",
      "poi_address": "5801 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_long_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-202f-765e-9c77-4a0a6d115716.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc974-202f-765e-9c77-4a0a6d115716",
        "storage_key": "property/6767906449167594/019fc974-202f-765e-9c77-4a0a6d115716.webp",
        "width": 1170,
        "height": 797
      },
      "poi_business_url": "https://www.visitthemap.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9011883457387750483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-at-prairiefire",
      "poi_latitude": "38.8819446",
      "poi_longitude": "-94.6520905",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-333-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-435c-74ba-a763-9982d4cf6ec3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-435c-74ba-a763-9982d4cf6ec3",
        "storage_key": "property/6767906449167594/019fc974-435c-74ba-a763-9982d4cf6ec3.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdDvHPHBwIcRU-TQ6kGkEH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_924143db-c10d-4270-bdd0-0defcc6f55f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "AMC Prairiefire 17",
      "poi_type": "Entertainment",
      "poi_address": "5724 W 136th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Comfortable entertainment venue featuring a full menu alongside movie screenings of new releases.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-8de5-704c-a94c-027d1f83fd50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-8de5-704c-a94c-027d1f83fd50",
        "storage_key": "property/6767906449167594/019fc977-8de5-704c-a94c-027d1f83fd50.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-prairiefire-17?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3727223515720771879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-prairiefire-17",
      "poi_latitude": "38.8826984",
      "poi_longitude": "-94.651566",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-553-3075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-b882-75b8-8c20-9cf6aaf26295.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc977-b882-75b8-8c20-9cf6aaf26295",
        "storage_key": "property/6767906449167594/019fc977-b882-75b8-8c20-9cf6aaf26295.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7fXu5_DBwIcRJ-kENQrCuTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_34e94b01-b2a5-4332-bdf8-f9cc84307847",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "810 Entertainment - Overland Park",
      "poi_type": "Entertainment",
      "poi_address": "13500 Nall Ave, Overland Park, KS 66224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-d5eb-710d-ac60-1042f33114d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-d5eb-710d-ac60-1042f33114d7",
        "storage_key": "property/6767906449167594/01a0101a-d5eb-710d-ac60-1042f33114d7.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://810bowling.com/810-entertainment-overland-park-ks",
      "poi_directions_map_url": "https://maps.google.com/?cid=11623012279752903673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "810-entertainment---overland-park",
      "poi_latitude": "38.8828352",
      "poi_longitude": "-94.6497927",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-600-7088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4329-7552-8ded-6be0ddb359fb",
        "storage_key": "property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ298S-n_BwIcR-cusShY8TaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_2e471fbe-e08e-4201-9176-bb8353dd84d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "B&B Theatres Overland Park 16",
      "poi_type": "Entertainment",
      "poi_address": "8601 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_long_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019ff6c3-4f39-74d4-99ca-836501614ee0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-4f39-74d4-99ca-836501614ee0",
        "storage_key": "property/6767906449167594/019ff6c3-4f39-74d4-99ca-836501614ee0.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://www.bbtheatres.com/our-theatres/x0uvh-b-and-b-overland-park-16/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6259761698616561138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bb-theatres-overland-park-16",
      "poi_latitude": "38.8812512",
      "poi_longitude": "-94.6835183",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-871-5352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-b882-75b8-8c20-9cf6aaf26295.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc977-b882-75b8-8c20-9cf6aaf26295",
        "storage_key": "property/6767906449167594/019fc977-b882-75b8-8c20-9cf6aaf26295.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJDWO_qc3BwIcR8s2iaBkk31Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_6b275512-3066-4e6c-9935-7bbf9b4e5a02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Nerman Museum of Contemporary Art",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_long_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-202f-765e-9c77-4e1570480221.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc974-202f-765e-9c77-4e1570480221",
        "storage_key": "property/6767906449167594/019fc974-202f-765e-9c77-4e1570480221.webp",
        "width": 1080,
        "height": 830
      },
      "poi_business_url": "http://www.nermanmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4973184191241098516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nerman-museum-of-contemporary-art",
      "poi_latitude": "38.924852",
      "poi_longitude": "-94.726824",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-469-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-435c-74ba-a763-9982d4cf6ec3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-435c-74ba-a763-9982d4cf6ec3",
        "storage_key": "property/6767906449167594/019fc974-435c-74ba-a763-9982d4cf6ec3.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRFJWDQaxMBEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_b0dcb0a0-be5c-4f42-a645-5d97ee12d7a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Topgolf Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "10611 Nall Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-1ca4-70d9-bd38-dc7645a3de45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc974-1ca4-70d9-bd38-dc7645a3de45",
        "storage_key": "property/6767906449167594/019fc974-1ca4-70d9-bd38-dc7645a3de45.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "https://topgolf.com/us/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4737452325202402593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-overland-park",
      "poi_latitude": "38.9364597",
      "poi_longitude": "-94.64818",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-562-9713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4319-757b-b1a6-48a3fd13fc11",
        "storage_key": "property/6767906449167594/019fc974-4319-757b-b1a6-48a3fd13fc11.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJibz1RyvqwIcRIZ0JKMrPvkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5a8e9feb-72e2-4ef9-8e25-ad890067300a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Deanna Rose Children's Farmstead",
      "poi_type": "Entertainment",
      "poi_address": "13800 Switzer Rd, Overland Park, KS 66221, USA",
      "poi_short_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_long_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-8e59-70eb-a743-18a3de104a15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-8e59-70eb-a743-18a3de104a15",
        "storage_key": "property/6767906449167594/019fc977-8e59-70eb-a743-18a3de104a15.webp",
        "width": 640,
        "height": 349
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/deanna-rose-childrens-farmstead/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7835830010939554497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deanna-rose-childrens-farmstead",
      "poi_latitude": "38.877729",
      "poi_longitude": "-94.703345",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-897-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4329-7552-8ded-6be0ddb359fb",
        "storage_key": "property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6IUwjvAwIcRwbplAuF1vmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f556d7ab-135e-40bb-8bc3-19dd33efa75e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Scheels",
      "poi_type": "Shopping & Retail",
      "poi_address": "6503 W 135th St STE 88, Overland Park, KS 66223, USA",
      "poi_short_description": "Chain with apparel, shoes & gear for sports & outdoor recreation, plus merchandise with team logos.",
      "poi_long_description": "Chain with apparel, shoes & gear for sports & outdoor recreation, plus merchandise with team logos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-d68f-74cb-b334-b06e97749835.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-d68f-74cb-b334-b06e97749835",
        "storage_key": "property/6767906449167594/01a0101a-d68f-74cb-b334-b06e97749835.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.scheels.com/store/overland-park/088?utm_source=google&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=1094253745788337078&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scheels",
      "poi_latitude": "38.8804238",
      "poi_longitude": "-94.6607748",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-897-3030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4340-710a-9b75-0d66d6fa8a10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4340-710a-9b75-0d66d6fa8a10",
        "storage_key": "property/6767906449167594/019fc974-4340-710a-9b75-0d66d6fa8a10.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvUOZyt7BwIcRtrva8_uRLw8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_aa55ab23-9ba1-4b4f-a177-3c3c0dc885d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "14401 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-1e3f-77b1-9a20-3a9015f4d111.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc974-1e3f-77b1-9a20-3a9015f4d111",
        "storage_key": "property/6767906449167594/019fc974-1e3f-77b1-9a20-3a9015f4d111.webp",
        "width": 909,
        "height": 1186
      },
      "poi_business_url": "https://www.urbanair.com/kansas-overland-park/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=11815076256041431885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "38.8673367",
      "poi_longitude": "-94.664787",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-298-0626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4329-7552-8ded-6be0ddb359fb",
        "storage_key": "property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5eXXF5bBwIcRTXOAg0GV96M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_a5828f8b-7a21-4a16-997d-a96e9eef878d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Saint Luke's South Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "12300 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-9037-7278-afb5-3c66fe444142.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-9037-7278-afb5-3c66fe444142",
        "storage_key": "property/6767906449167594/019fc977-9037-7278-afb5-3c66fe444142.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-south-hospital?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=8966224544508452770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-south-hospital",
      "poi_latitude": "38.9041982",
      "poi_longitude": "-94.6695167",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-317-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4359-76ab-983e-fb5d5de44c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4359-76ab-983e-fb5d5de44c0e",
        "storage_key": "property/6767906449167594/019fc974-4359-76ab-983e-fb5d5de44c0e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkT2aF3LqwIcRop_Q17dtbnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_ce6e8322-d491-4202-bd80-a70b14e34e5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "CareNow Urgent Care - Corbin Park",
      "poi_type": "Health and Wellness",
      "poi_address": "13761 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-dc9c-716a-89fa-56b42e403d53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-dc9c-716a-89fa-56b42e403d53",
        "storage_key": "property/6767906449167594/01a0101a-dc9c-716a-89fa-56b42e403d53.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.carenow.com/locations/kansas-city/corbin-park?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17803688775260742105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---corbin-park",
      "poi_latitude": "38.87859419999999",
      "poi_longitude": "-94.6672924",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-814-3788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4329-7552-8ded-6be0ddb359fb",
        "storage_key": "property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX1b2mqnBwIcR2aEG9ZxoE_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_a9f70d60-e615-476a-8bdc-1ad634f209b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "9500 Antioch Rd, Overland Park, KS 66212, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-dc32-7709-bc1e-bdf15d63967f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-dc32-7709-bc1e-bdf15d63967f",
        "storage_key": "property/6767906449167594/01a0101a-dc32-7709-bc1e-bdf15d63967f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-9500+antioch+rd-overland+park-ks-66212/id=11370",
      "poi_directions_map_url": "https://maps.google.com/?cid=15822532587315318245&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "38.9561947",
      "poi_longitude": "-94.6869725",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-381-0138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-b89b-7501-b03b-eb2ba1eb4634.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc977-b89b-7501-b03b-eb2ba1eb4634",
        "storage_key": "property/6767906449167594/019fc977-b89b-7501-b03b-eb2ba1eb4634.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD9KcrQrrwIcR5c34iY7tlNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_70ff622b-2a46-410c-9b2a-8ebd67b4aaa4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "YogaSix Overland Park",
      "poi_type": "Health and Wellness",
      "poi_address": "6555 W 119th St, Overland Park, KS 66209, USA",
      "poi_short_description": "Relaxed yoga studio offering a variety of classes including hot and restorative types, plus a shop selling yoga apparel.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-98de-77d1-96fe-dfbeb7131074.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-98de-77d1-96fe-dfbeb7131074",
        "storage_key": "property/6767906449167594/019fc977-98de-77d1-96fe-dfbeb7131074.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.yogasix.com/overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4666487347789615135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yogasix-overland-park",
      "poi_latitude": "38.9124848",
      "poi_longitude": "-94.6603913",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-660-9230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4347-76ac-ab62-ff5df0fce583",
        "storage_key": "property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkS5c-rTrwIcRH9DayYSxwkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_6c31c15f-ff2f-4a8d-b8e8-1696b025fe49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "6800 138th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Upscale gym with a spa, an indoor and an outdoor pool, plus a hair salon.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-2659-779f-8153-7c56d6ba8fb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc974-2659-779f-8153-7c56d6ba8fb6",
        "storage_key": "property/6767906449167594/019fc974-2659-779f-8153-7c56d6ba8fb6.webp",
        "width": 1200,
        "height": 627
      },
      "poi_business_url": "https://www.lifetime.life/locations/ks/overland-park?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=6007822183813280658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "38.8789466",
      "poi_longitude": "-94.6645722",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-239-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4329-7552-8ded-6be0ddb359fb",
        "storage_key": "property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeyRfIerBwIcRkvPmA3ISYFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_df987d03-c580-4a8c-b41b-5e43a3c970f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "StretchLab",
      "poi_type": "Health and Wellness",
      "poi_address": "6645 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Fitness club offering group classes and one-on-one assisted stretching services in a communal space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-d90f-722f-b6c3-ef9f7fb99f42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-d90f-722f-b6c3-ef9f7fb99f42",
        "storage_key": "property/6767906449167594/01a0101a-d90f-722f-b6c3-ef9f7fb99f42.webp",
        "width": 1280,
        "height": 1088
      },
      "poi_business_url": "https://www.stretchlab.com/location/overlandpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=8235989840250690368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stretchlab",
      "poi_latitude": "38.8833215",
      "poi_longitude": "-94.6621095",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-562-1349",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4329-7552-8ded-6be0ddb359fb",
        "storage_key": "property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUYi08zvBwIcRQFveoR8dTHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_d81d0b15-d941-48a2-8bad-866d27f15112",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "11411 Metcalf Ave, Overland Park, KS 66210, USA",
      "poi_short_description": "Chain gym with a membership requirement offering tanning and plenty of equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-29dc-712c-9b2d-f3e8f261b442.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc974-29dc-712c-9b2d-f3e8f261b442",
        "storage_key": "property/6767906449167594/019fc974-29dc-712c-9b2d-f3e8f261b442.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/overland-park-metcalf-ks?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=10468351881021403037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.9194305",
      "poi_longitude": "-94.6658236",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-788-6960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4329-7552-8ded-6be0ddb359fb",
        "storage_key": "property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3xUhl9DrwIcRna8SdJIOR5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f88a3029-5117-48fb-878f-a25cf4d7dd22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Thomas S. Stoll Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12500 W 119th St, Overland Park, KS 66210, USA",
      "poi_short_description": "Public 79-acre park with 7 ball fields, a fishing lake, a playground & a scenic nature trail.",
      "poi_long_description": "Public 79-acre park with 7 ball fields, a fishing lake, a playground & a scenic nature trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-9b90-7458-9ce9-dda6e07f7b73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-9b90-7458-9ce9-dda6e07f7b73",
        "storage_key": "property/6767906449167594/019fc977-9b90-7458-9ce9-dda6e07f7b73.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.jcprd.com/parks_facilities/stoll_park.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=11904290777782419563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thomas-s-stoll-memorial-park",
      "poi_latitude": "38.9133269",
      "poi_longitude": "-94.7313061",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 913-438-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-431b-766b-91c1-3886fdee975e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-431b-766b-91c1-3886fdee975e",
        "storage_key": "property/6767906449167594/019fc974-431b-766b-91c1-3886fdee975e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ06uvXjSVwIcRawCuCGSJNKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b19d9ce3-1cca-4865-b58b-90c6a695e769",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Quivira Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11901 Quivira Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "Small community park featuring a playground, picnic tables & 2 sand volleyball courts.",
      "poi_long_description": "Small community park featuring a playground, picnic tables & 2 sand volleyball courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-9ba7-73ff-9760-346b15bee485.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-9ba7-73ff-9760-346b15bee485",
        "storage_key": "property/6767906449167594/019fc977-9ba7-73ff-9760-346b15bee485.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17176832562132200599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quivira-park",
      "poi_latitude": "38.9107813",
      "poi_longitude": "-94.7229342",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-431b-766b-91c1-3886fdee975e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-431b-766b-91c1-3886fdee975e",
        "storage_key": "property/6767906449167594/019fc974-431b-766b-91c1-3886fdee975e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmbS_K7TqwIcRl6xAYDVeYO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d0ff6b92-4a78-44e3-85dc-778e68cfdfb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Sykes/Lady Overland Park Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12501 Quivira Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "Public golf course offering 18 holes, a restaurant, and views.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-3614-730e-9f64-4c332bcf9a3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc974-3614-730e-9f64-4c332bcf9a3d",
        "storage_key": "property/6767906449167594/019fc974-3614-730e-9f64-4c332bcf9a3d.webp",
        "width": 561,
        "height": 396
      },
      "poi_business_url": "http://www.golfop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14988297311304615467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sykeslady-overland-park-golf-course",
      "poi_latitude": "38.90176690000001",
      "poi_longitude": "-94.7222016",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-890-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-430f-745d-8c87-05a7719d40f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-430f-745d-8c87-05a7719d40f3",
        "storage_key": "property/6767906449167594/019fc974-430f-745d-8c87-05a7719d40f3.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJW7pZBVaVwIcRKwZBRP4gAdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_0966bbbc-d821-4322-b866-c869ee738eb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Oak Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11506 W 106th St, Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-e063-76ba-9e90-be423b190a0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-e063-76ba-9e90-be423b190a0a",
        "storage_key": "property/6767906449167594/01a0101a-e063-76ba-9e90-be423b190a0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8304000677742693745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park",
      "poi_latitude": "38.939574",
      "poi_longitude": "-94.72103",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-431b-766b-91c1-3886fdee975e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-431b-766b-91c1-3886fdee975e",
        "storage_key": "property/6767906449167594/019fc974-431b-766b-91c1-3886fdee975e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ27uZyy7rwIcRcc10s568PXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7b9149a8-ca87-4070-9460-24edf3dbfa7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Valleybrooke Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-dedf-7518-951a-c392b5cbcc16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-dedf-7518-951a-c392b5cbcc16",
        "storage_key": "property/6767906449167594/01a0101a-dedf-7518-951a-c392b5cbcc16.webp",
        "width": 850,
        "height": 1280
      },
      "poi_business_url": "https://www.opkansas.org/things-to-see-and-do/parks/list-of-city-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17213302183367309152&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valleybrooke-park",
      "poi_latitude": "38.9332727",
      "poi_longitude": "-94.7190227",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-431b-766b-91c1-3886fdee975e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-431b-766b-91c1-3886fdee975e",
        "storage_key": "property/6767906449167594/019fc974-431b-766b-91c1-3886fdee975e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSV_Jw9fqwIcRYHcQwyLv4e4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_96a776e5-3bf0-4087-8808-dc63d47647e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Indian Valley",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11606 Knox St, Overland Park, KS 66210, USA",
      "poi_short_description": "Community park offering sports courts, fields & a roller hockey rink, multiuse trails & picnic area.",
      "poi_long_description": "Community park offering sports courts, fields & a roller hockey rink, multiuse trails & picnic area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-dd45-778b-84a8-fd7a62bcd906.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-dd45-778b-84a8-fd7a62bcd906",
        "storage_key": "property/6767906449167594/01a0101a-dd45-778b-84a8-fd7a62bcd906.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/parks/list-of-city-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1477092456172255444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indian-valley",
      "poi_latitude": "38.9182931",
      "poi_longitude": "-94.7004829",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-431b-766b-91c1-3886fdee975e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-431b-766b-91c1-3886fdee975e",
        "storage_key": "property/6767906449167594/019fc974-431b-766b-91c1-3886fdee975e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWxDPuzqwIcR1HiOTsOvfxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e0ccc165-978f-4af6-bff8-60036dc2be95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Rosehill East Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12680 W 105th St, Lenexa, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-e441-714a-8b03-8d723bfb9d80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-e441-714a-8b03-8d723bfb9d80",
        "storage_key": "property/6767906449167594/01a0101a-e441-714a-8b03-8d723bfb9d80.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5255112224046864156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosehill-east-park",
      "poi_latitude": "38.9389723",
      "poi_longitude": "-94.7325721",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-431b-766b-91c1-3886fdee975e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-431b-766b-91c1-3886fdee975e",
        "storage_key": "property/6767906449167594/019fc974-431b-766b-91c1-3886fdee975e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJO_HjE-SVwIcRHFcgmbno7Ug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_820eb9f4-abd2-443e-8b96-1fe6746b8b53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Bluejacket Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10101 Bond St, Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-e3e2-70de-87e5-65a9afb241b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-e3e2-70de-87e5-65a9afb241b2",
        "storage_key": "property/6767906449167594/01a0101a-e3e2-70de-87e5-65a9afb241b2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2831659018989769284&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bluejacket-park",
      "poi_latitude": "38.9461948",
      "poi_longitude": "-94.7166283",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-431b-766b-91c1-3886fdee975e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-431b-766b-91c1-3886fdee975e",
        "storage_key": "property/6767906449167594/019fc974-431b-766b-91c1-3886fdee975e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ40o3ljrrwIcRRJLq_98STCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b25fc991-67ca-46ef-8dbc-0673c57de2ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Oak Park Mall Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16122160475460681538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall-park--ride",
      "poi_latitude": "38.9552209",
      "poi_longitude": "-94.7216049",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-b8d5-73db-a045-a9545332eb36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc977-b8d5-73db-a045-a9545332eb36",
        "storage_key": "property/6767906449167594/019fc977-b8d5-73db-a045-a9545332eb36.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwpg4UnrwIcRQj-tl4hrvd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_7181d02f-67ea-4467-b973-1ae3983e876f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Midwest Trust Center",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_long_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-e0d5-73ea-90a6-a77711e8d6d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-e0d5-73ea-90a6-a77711e8d6d6",
        "storage_key": "property/6767906449167594/01a0101a-e0d5-73ea-90a6-a77711e8d6d6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jccc.edu/midwest-trust-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=333406106616415315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midwest-trust-center",
      "poi_latitude": "38.9252624",
      "poi_longitude": "-94.7279145",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-469-4445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4329-7552-8ded-6be0ddb359fb",
        "storage_key": "property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRU0TRZhZ_oAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_7224b2a8-3963-4716-99b9-06d5162652b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Mission Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5251 Johnson Dr, Roeland Park, KS 66205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ridekc.org/locations/mission_transit_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14750820283784844061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-transit-center",
      "poi_latitude": "39.0229186",
      "poi_longitude": "-94.6460432",
      "poi_miles_from_property": "10.9",
      "poi_walking_minutes": "4 hours 4 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-b8d5-73db-a045-a9545332eb36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc977-b8d5-73db-a045-a9545332eb36",
        "storage_key": "property/6767906449167594/019fc977-b8d5-73db-a045-a9545332eb36.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RGVf9XtwIcRHVOfGOVwtcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_67c8ae86-82b4-43d6-858a-0872b4b88235",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Shawnee Station Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Shawnee, KS 66217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6607180038980660494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shawnee-station-park-and-ride",
      "poi_latitude": "39.00885",
      "poi_longitude": "-94.764741",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-b883-73b3-97e5-b7898ddd0660.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc977-b883-73b3-97e5-b7898ddd0660",
        "storage_key": "property/6767906449167594/019fc977-b883-73b3-97e5-b7898ddd0660.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJDR_vmwaTwIcRDm1-Nj1rsVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_112ce1db-a131-445e-8698-b7b2c26d147c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Cosentino's Price Chopper",
      "poi_type": "Shopping & Retail",
      "poi_address": "22210 W 66th St, Shawnee, KS 66226, USA",
      "poi_short_description": "Grocery outlet selling produce, meat, and organic products, plus prepared foods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-e2a9-7433-944d-40427e7202cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-e2a9-7433-944d-40427e7202cf",
        "storage_key": "property/6767906449167594/01a0101a-e2a9-7433-944d-40427e7202cf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mypricechopper.com/store-details?storeId=86",
      "poi_directions_map_url": "https://maps.google.com/?cid=5811553679194901116&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cosentinos-price-chopper",
      "poi_latitude": "39.0099101",
      "poi_longitude": "-94.843718",
      "poi_miles_from_property": "12.4",
      "poi_walking_minutes": "4 hours 34 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 913-422-2130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-431a-772b-a9c5-fd3fafea30f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-431a-772b-a9c5-fd3fafea30f1",
        "storage_key": "property/6767906449167594/019fc974-431a-772b-a9c5-fd3fafea30f1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ43RprQeRwIcRfMqGwUfJplA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c941de09-6af8-499d-a647-53a6b5d16df0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Hyatt Place Kansas City/Lenexa City Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "8741 Ryckert St, Lenexa, KS 66219, USA",
      "poi_short_description": "Understated rooms & suites in a relaxed hotel with a gym, an indoor pool & a cafe/bar.",
      "poi_long_description": "Understated rooms & suites in a relaxed hotel with a gym, an indoor pool & a cafe/bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-e138-754c-bffd-00aa1de862eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-e138-754c-bffd-00aa1de862eb",
        "storage_key": "property/6767906449167594/01a0101a-e138-754c-bffd-00aa1de862eb.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "https://www.hyatt.com/hyatt-place/en-US/mkczl-hyatt-place-kansas-city-lenexa-city-center?src=corp_lclb_google_seo_mkczl&utm_source=google&utm_medium=organic&utm_campaign=lmr",
      "poi_directions_map_url": "https://maps.google.com/?cid=6789786362053878651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hyatt-place-kansas-citylenexa-city-center",
      "poi_latitude": "38.9690345",
      "poi_longitude": "-94.7777598",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-742-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-ee39-73fe-b0ff-96fa5d5981c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0101a-ee39-73fe-b0ff-96fa5d5981c8",
        "storage_key": "property/6767906449167594/01a0101a-ee39-73fe-b0ff-96fa5d5981c8.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJYwaLj3mUwIcRe2MD87gqOl4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_36e02c5c-7137-4526-adbb-82078b80ab19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-a80d-76aa-bf76-dc1564dd7378.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-a80d-76aa-bf76-dc1564dd7378",
        "storage_key": "property/6767906449167594/019fc977-a80d-76aa-bf76-dc1564dd7378.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3014091",
      "poi_longitude": "-94.7104536",
      "poi_miles_from_property": "38.6",
      "poi_walking_minutes": "14 hours 22 mins",
      "poi_biking_minutes": "4 hours 17 mins",
      "poi_driving_minutes": "38 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-458e-7578-a22b-a9ea6dabc0b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-458e-7578-a22b-a9ea6dabc0b5",
        "storage_key": "property/6767906449167594/019fc974-458e-7578-a22b-a9ea6dabc0b5.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_6cc98178-9ac0-4aef-8204-ac47ea310b33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Kansas City",
      "poi_type": "Transportation & Transit",
      "poi_address": "30 W Pershing Rd Union Station, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-acde-75af-93e6-facd3a357888.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-acde-75af-93e6-facd3a357888",
        "storage_key": "property/6767906449167594/019fc977-acde-75af-93e6-facd3a357888.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=KCY",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787247529242741214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city",
      "poi_latitude": "39.0847966",
      "poi_longitude": "-94.5853578",
      "poi_miles_from_property": "16.7",
      "poi_walking_minutes": "6 hours 10 mins",
      "poi_biking_minutes": "1 hour 45 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-b898-7394-b15e-fec284ea1531.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc977-b898-7394-b15e-fec284ea1531",
        "storage_key": "property/6767906449167594/019fc977-b898-7394-b15e-fec284ea1531.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbu2nD_wwIcR3kn96I8BjzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_29ee8d2c-2888-4c62-ba0e-051af2a9b816",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Overland Park Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10500 Quivira Rd, Overland Park, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-a807-7161-942c-ebf2655bfb83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-a807-7161-942c-ebf2655bfb83",
        "storage_key": "property/6767906449167594/019fc977-a807-7161-942c-ebf2655bfb83.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/overland-park-regional-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13555409796355494155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-regional-medical-center",
      "poi_latitude": "38.9376197",
      "poi_longitude": "-94.7261812",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-541-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4359-76ab-983e-fb5d5de44c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4359-76ab-983e-fb5d5de44c0e",
        "storage_key": "property/6767906449167594/019fc974-4359-76ab-983e-fb5d5de44c0e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cFCWJzAwIcRC5Ge4GN9Hrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d8d9615b-47fc-49a3-8cad-bbeff314b8d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Regents Center",
      "poi_type": "Education",
      "poi_address": "12600 Quivira Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101a-e907-7359-8241-deaec207dfbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101a-e907-7359-8241-deaec207dfbc",
        "storage_key": "property/6767906449167594/01a0101a-e907-7359-8241-deaec207dfbc.webp",
        "width": 1280,
        "height": 636
      },
      "poi_business_url": "http://edwardscampus.ku.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17970494846537853263&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regents-center",
      "poi_latitude": "38.8991152",
      "poi_longitude": "-94.724779",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-897-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4347-76ac-ab62-ff5df0fce583",
        "storage_key": "property/6767906449167594/019fc974-4347-76ac-ab62-ff5df0fce583.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqe8TXKzqwIcRT2ng5dkFZPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_92f9e84d-3afc-4ff8-8d5f-65315f7884e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Black & Veatch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11401 Lamar Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-ac52-713e-93e6-117079620bc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc977-ac52-713e-93e6-117079620bc2",
        "storage_key": "property/6767906449167594/019fc977-ac52-713e-93e6-117079620bc2.webp",
        "width": 1280,
        "height": 653
      },
      "poi_business_url": "http://www.bv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15245877116558125981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black--veatch",
      "poi_latitude": "38.9250015",
      "poi_longitude": "-94.6553624",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-458-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4329-7552-8ded-6be0ddb359fb",
        "storage_key": "property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyTe2TrqwIcRnSu0HXY8lNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_b8811076-16f5-44c2-9a43-dc43a5e0ab61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "T-Mobile Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6220 Sprint Pkwy, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-3ca2-77ec-a2e9-e74297c3d608.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc974-3ca2-77ec-a2e9-e74297c3d608",
        "storage_key": "property/6767906449167594/019fc974-3ca2-77ec-a2e9-e74297c3d608.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16065491002476993060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "t-mobile-corporate-office",
      "poi_latitude": "38.9158914",
      "poi_longitude": "-94.6621181",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 855-977-5086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4329-7552-8ded-6be0ddb359fb",
        "storage_key": "property/6767906449167594/019fc974-4329-7552-8ded-6be0ddb359fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI0P_xjzrwIcRJBrguPIW9N4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_3960f8b4-f2c8-440d-837b-2b064c3eebf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Menorah Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5721 W 119th St, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-30a1-75ca-b1f2-27a7d789a2f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc974-30a1-75ca-b1f2-27a7d789a2f3",
        "storage_key": "property/6767906449167594/019fc974-30a1-75ca-b1f2-27a7d789a2f3.webp",
        "width": 1280,
        "height": 983
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/menorah-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13288974551408218760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "menorah-medical-center",
      "poi_latitude": "38.9108041",
      "poi_longitude": "-94.6515422",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-498-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4359-76ab-983e-fb5d5de44c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4359-76ab-983e-fb5d5de44c0e",
        "storage_key": "property/6767906449167594/019fc974-4359-76ab-983e-fb5d5de44c0e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJa9T6FxnqwIcRiJLkTfLra7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_d9ff5656-eca0-40f5-97d6-3f57c8f796af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "OptumRx Fulfillment",
      "poi_type": "Health and Wellness",
      "poi_address": "6800 W 115th St #600, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019ff6c3-61a7-77d6-9ef4-794aea776350.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-61a7-77d6-9ef4-794aea776350",
        "storage_key": "property/6767906449167594/019ff6c3-61a7-77d6-9ef4-794aea776350.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9191309365621035853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "optumrx-fulfillment",
      "poi_latitude": "38.9196071",
      "poi_longitude": "-94.6643722",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc977-b89b-7501-b03b-eb2ba1eb4634.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc977-b89b-7501-b03b-eb2ba1eb4634",
        "storage_key": "property/6767906449167594/019fc977-b89b-7501-b03b-eb2ba1eb4634.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOSlrPD_qwIcRTROQnisXjn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_c863066b-fce6-4a91-926f-f1a76dbf509e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "Children's Mercy Kansas",
      "poi_type": "Health and Wellness",
      "poi_address": "5808 W 110th St, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-2de0-7524-b130-166f40ee0d32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc974-2de0-7524-b130-166f40ee0d32",
        "storage_key": "property/6767906449167594/019fc974-2de0-7524-b130-166f40ee0d32.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.childrensmercy.org/Kansas/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8535209985424805612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-mercy-kansas",
      "poi_latitude": "38.9299718",
      "poi_longitude": "-94.6522904",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-696-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4359-76ab-983e-fb5d5de44c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4359-76ab-983e-fb5d5de44c0e",
        "storage_key": "property/6767906449167594/019fc974-4359-76ab-983e-fb5d5de44c0e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ03Xo8C7qwIcR7M6coEIoc3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_56f5c50f-b25c-4e95-b708-521abe6b10a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "custom",
      "poi_name": "AdventHealth South Overland Park Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "7820 W 165th St, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019ff6c3-6077-7435-97a4-cf86bacb6290.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c3-6077-7435-97a4-cf86bacb6290",
        "storage_key": "property/6767906449167594/019ff6c3-6077-7435-97a4-cf86bacb6290.webp",
        "width": 1280,
        "height": 727
      },
      "poi_business_url": "https://www.adventhealth.com/hospital/adventhealth-south-overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9373271053670540671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-south-overland-park-hospital",
      "poi_latitude": "38.8328311",
      "poi_longitude": "-94.6805899",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-373-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/019fc974-4359-76ab-983e-fb5d5de44c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc974-4359-76ab-983e-fb5d5de44c0e",
        "storage_key": "property/6767906449167594/019fc974-4359-76ab-983e-fb5d5de44c0e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJxQPX-BrBwIcRf-V7kVyMFII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "ec_4a3670227e3dd6dd7aefed78",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7e5b5f3c68e0feeacb2d5261",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_92441f872b11a878384d9a69",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_96693a712e5e1a45dd9c38ee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0bbc3c44f72a7301843b4f5d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_74f6c97dcc254914227479ea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_c72bc922-2516-439c-9d35-4795060417eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "rating": "4.0",
      "name": "Steve Simonis",
      "text": "Overall it’s good, but the dog cans are often overfilled all weekend and no dog bags available. Maybe they empty and do refills on Fridays. Also, the mow crew that is hired has no respect for our vehicles, I’ve caught them blowing grass, and worse sand off streets straight into the parked cars.  I have great neighbors and I enjoy the staff, though I guess the apartments are understaffed.  Thank you. One last thing, every apartment I’ve lived in has had a trash compactor that we could hit a button and it would take the trash, here the trash is always overflowing and the smell is awful. Thanks",
      "date": "2026-06-21",
      "title": ""
    },
    {
      "id": "custom_115a02dd-517f-41d2-b3bf-081d3201cdaf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "rating": "5.0",
      "name": "HETHER GOOLEY",
      "text": "I recently toured Creekside Apartment Homes and had an amazing experience! The community is beautiful, well-maintained, and has so many great amenities. From the moment I walked in, I felt welcomed and appreciated.\nKaye, the Property Manager, and Makeyla, the Assistant Property Manager, were both incredibly friendly, knowledgeable, and professional. They took the time to answer all of my questions, explain the leasing process, and show me everything the community has to offer. Their customer service was outstanding, and it was clear they genuinely care about their residents and prospective residents.\nThe apartments and grounds were clean and inviting, and I left feeling excited about the possibility of making Creekside my new home. If you're looking for a community with a great team and a welcoming atmosphere, I highly recommend Creekside Apartment Homes!",
      "date": "2026-06-17",
      "title": ""
    },
    {
      "id": "custom_f52a2d61-0b83-43d3-8123-a2ad5ee7d6d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "rating": "4.0",
      "name": "Susan Coughlin",
      "text": "I have been here almost 4 years and have been very happy with the quick response to maintenance requests. The area appears quiet and safe as well. Grounds are kept up well. That being said, I am curious if any updates are planned for inside the apartments. The windows are terrible (you can hear and feel the wind through them).\nAppliances are dated as are the carpets. Have requested the manager contact me three times about possible carpet replacement when renters are still in the apartment but heard nothing back.",
      "date": "2026-06-18",
      "title": ""
    },
    {
      "id": "custom_afa3fd55-d209-4b15-a7e7-fa4cda93d2ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "rating": "5.0",
      "name": "Pradeep reddy",
      "text": "I toured this apartment recently and really liked what I saw. The leasing team especially Stephanie was kind, responsive, and made the visit easy and comfortable. The apartment felt inviting, and the amenities and layout stood out to me.\nOnce again thanks Stephanie for such a nice and elaborate details shared over the leasing/ renting the appartment terms and conditions",
      "date": "2026-04-20",
      "title": ""
    },
    {
      "id": "custom_3b02d4c3-b7ff-4343-b890-ec350d4b5245",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "rating": "5",
      "name": "Faith Poole",
      "text": "I loved living at Creekside. The office ladies there are always on it and are some of the sweetest and most helpful people. They always communicated very well. Any maintenance request was handled quickly.   .\n",
      "date": "2026-09-03",
      "title": "false"
    },
    {
      "id": "custom_6bd24ddd-ad98-4577-aa15-1c258e7fc95f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "rating": "5",
      "name": "Crystal Roberts",
      "text": "Such a beautiful apartment complex I moved in and love all the beautiful trails here and people!",
      "date": "2026-08-03",
      "title": "false"
    },
    {
      "id": "custom_f9fa8695-cb10-4af0-abe7-4bf8602c3d29",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "rating": "5",
      "name": "Alfred Okao",
      "text": "Great and very helpful staff. Any issues I have had with maintenance is always resolved promptly\n",
      "date": "2026-07-03",
      "title": "false"
    },
    {
      "id": "custom_088e8017-0848-49a7-8c86-c4fc4e567946",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "rating": "5",
      "name": "Ken Murray",
      "text": "I have enjoyed my three years at Creekside. They do a great job of keeping the place looking good and I love the location with the walking trail out back.\n",
      "date": "2026-07-01",
      "title": "false"
    },
    {
      "id": "custom_ec958e4f-a2af-4adc-a579-651bfe0eb29a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "rating": "5",
      "name": "Bethany Rupert",
      "text": "Makeyla was extremely helpful with our move from out of state. She went above and beyond for us. Highly recommend!!!\n",
      "date": "2026-07-01",
      "title": "false"
    },
    {
      "id": "custom_d2da58ed-9545-4eee-b2a6-e149af6d4e97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "rating": "5",
      "name": "Kimberly Campbell",
      "text": "This is my fifth year here. I find the management and maintenance team personable and quick to respond to requests. The snow scooping in winter is organized and very helpful. The lawn care the rest of the year makes this campus beautiful. I think we have the prettiest pool in town. My apartment is comfortable and bug free, which I understand can be a problem in other areas. ",
      "date": "2026-06-02",
      "title": "false"
    },
    {
      "id": "custom_3933e5c6-e797-45a8-b563-fa1d20ce2fe1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "rating": "5",
      "name": "Mike Norris",
      "text": "Love this place! Management and maintenance are top-notch!\n",
      "date": "2026-06-30",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_c27a6054cd5f3302d111416d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-cdf6-751f-a104-7d33a7ebc4b9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101f-cdf6-751f-a104-7d33a7ebc4b9",
        "storage_key": "property/6767906449167594/01a0101f-cdf6-751f-a104-7d33a7ebc4b9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "BELMONT",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=bbbtZSWzQuG"
    },
    {
      "id": "ec_c902d23fc81e2abdcd4c3168",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-cdd4-71ef-a25c-46d8a101d9f1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101f-cdd4-71ef-a25c-46d8a101d9f1",
        "storage_key": "property/6767906449167594/01a0101f-cdd4-71ef-a25c-46d8a101d9f1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "CHURCHILL",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=pu8f67g4aW5"
    },
    {
      "id": "ec_2e24250c3c5246d0efa338dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-cd32-7165-9298-63229d33080d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101f-cd32-7165-9298-63229d33080d",
        "storage_key": "property/6767906449167594/01a0101f-cd32-7165-9298-63229d33080d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "CALUMET",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kgmnDuKJG8t"
    },
    {
      "id": "ec_a052ffbdef80c03c2603dd4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167594/01a0101f-cdf5-735e-ace1-92cdec10a614.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101f-cdf5-735e-ace1-92cdec10a614",
        "storage_key": "property/6767906449167594/01a0101f-cdf5-735e-ace1-92cdec10a614.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "PREAKNESS",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kKQD6GLRiJd"
    }
  ],
  "faqs": [
    {
      "id": "custom_a6baffa4-f056-4dcf-8475-8f412e8c6591",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_6c4ed422-553e-4f4a-8cbe-55e54a83ebaf",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_467c2815-bae6-483b-8694-f3723a74c2f0",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_926b7760-bcf2-47f2-9c0e-31c9e40f6b93",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_f55ec05b-9a7d-4573-a1dd-e8d9e916ee18",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_bd1c6d2b-eb01-4023-8d38-ab5a3ffb626a",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_37cbdab4-ca8a-4fc4-b5c5-36ce151e3b90",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_babab69f-edab-44ff-a48e-6c1eaf6a30a8",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, trash, and electric.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_906fe5c5-c92f-4c89-b675-021ab9153b64",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_f82b8fae-de01-418d-9be8-1d1375dbb4a3",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_273d97f1-fada-4e20-a0d4-9db56409371f",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_e17f00dc-e564-43aa-b6e4-5e1cbcb3e48f",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_29ecd2bb-7966-4a42-84a7-2d7f4703bfd6",
      "question": "Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_5d42339a-d446-4f25-a1a4-4038c505b593",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer carports and detached garages. Please <a href=\"/contact-us\">contact the office</a> for our most current pricing and availability.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_cf068032-f812-4c89-92fc-134c4c05b842",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_d43f5889-0554-4498-9f0c-9bcd321aad32",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_cbeee563-73de-4e0a-bcfc-2c46e0c73884",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-3226-77bc-8ead-72628a30b115",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Creekside Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594"
    },
    {
      "lead_collector_id": "01a0c9ac-32af-723e-8cdc-06244f2cb302",
      "lead_source": "LANDING_PAGE",
      "name": "Creekside Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-overland-park-ks",
      "search_query": "apartments with in-unit laundry Overland Park KS",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Overland Park",
      "h2_subtitle": "Discover the convenience of apartments with in-unit laundry in Overland Park. Enjoy modern amenities and a welcoming community at Creekside.",
      "page_copy": "Experience the ultimate convenience at Creekside Apartment Homes, where each unit features in-unit laundry facilities right in the heart of Overland Park, KS. Our one-, two-, and three-bedroom apartments are designed with modern comforts, including stainless steel appliances and cable-ready units, ensuring a seamless living experience. Nestled in the vibrant Creekside neighborhood, residents enjoy easy access to highways and nearby shopping, making everyday life a breeze.\n\nLocated in Johnson County, Creekside Apartment Homes invite you to indulge in a lifestyle of comfort and accessibility. Our community offers inviting spaces and fantastic amenities that make living here a pleasure, such as a range and washer and dryer in every home. With direct access to nearby parks and trails, and being in a smoke-free environment, it's simple to lead an active, healthy lifestyle. Schedule a tour today and see why Creekside is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments Overland Park",
      "seo_description": "Find Overland Park apartments with in-unit laundry at Creekside. Enjoy modern amenities in a friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "creekside-apartments-air-conditioning",
      "search_query": "Creekside apartment homes with air conditioning",
      "category": "Amenity",
      "h1_title": "Creekside Apartments with Air Conditioning",
      "h2_subtitle": "Stay cool at Creekside Apartment Homes with our air-conditioned units. Comfort and convenience are just steps away.",
      "page_copy": "Welcome to Creekside Apartment Homes in Overland Park, KS, where staying cool is just one of the many comforts we offer. Our smoke-free community boasts one-, two-, and three-bedroom apartments equipped with efficient air conditioning, ensuring you a comfortable living environment throughout the seasons. Alongside in-unit amenities like stainless steel appliances and a washer and dryer, our homes provide the perfect blend of comfort and modern living.\n\nLocated in the desirable Creekside neighborhood in Johnson County, residents enjoy the benefits of easy access to both highways and parks. Our community spaces are inviting and perfect for relaxation or engaging with neighbors. With shopping destinations just moments away, Creekside Apartment Homes offer everything you need right at your fingertips. Discover a refreshing lifestyle here, and schedule a tour today to experience our beautifully air-conditioned homes firsthand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Creekside Apartments with AC Comfort",
      "seo_description": "Cool off at Creekside in Overland Park with our air-conditioned apartments. Discover comfort and convenience today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "dedicated-parking-apartments-johnson-county-ks",
      "search_query": "apartments with dedicated parking Johnson County KS",
      "category": "Amenity",
      "h1_title": "Apartments with Dedicated Parking in Johnson County",
      "h2_subtitle": "Enjoy the ease of dedicated parking at Creekside Apartments in Johnson County. Discover a stress-free living experience today.",
      "page_copy": "Located in the heart of Johnson County, KS, Creekside Apartment Homes offers the convenience of dedicated parking with our modern living spaces. Our community provides a selection of one-, two-, and three-bedroom apartments designed for comfort, featuring stainless steel appliances, in-unit laundry, and cable-ready access. Nestled in the welcoming Creekside neighborhood of Overland Park, residents enjoy a serene setting with easy access to major highways for effortless commuting.\n\nOur smoke-free community combines convenience and lifestyle amenities, including range and washer and dryer in all units, ensuring that you have everything you need at your fingertips. Enjoy the nearby parks and walking trails, perfect for outdoor relaxation and recreation. Whether you're coming home from a busy day or heading out for an adventure, dedicated parking ensures a hassle-free experience at Creekside. Schedule a tour today to see why our community is the perfect place for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dedicated Parking Apartments in Johnson County",
      "seo_description": "Find Johnson County apartments with dedicated parking at Creekside. Enjoy easy access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "overland-park-apartments-with-dishwasher",
      "search_query": "Overland Park apartments with dishwasher",
      "category": "Amenity",
      "h1_title": "Overland Park Apartments with Dishwasher",
      "h2_subtitle": "Simplify your life with apartments featuring dishwashers in Overland Park. Discover Creekside's modern conveniences today.",
      "page_copy": "Creekside Apartment Homes in Overland Park, KS offers the perfect combination of contemporary living and convenience. Our thoughtfully designed one-, two-, and three-bedroom apartments come with essential amenities like a dishwasher, ensuring you have more time to relax and enjoy life. Nestled in the popular Creekside neighborhood, our community is smoke-free and provides easy access to local highways, shopping, and beautiful parks.\n\nIn addition to a convenient dishwasher, each apartment at Creekside is furnished with stainless steel appliances, in-unit laundry, and is cable ready. Johnson County's thriving community provides vibrant living spaces alongside picturesque trails and community areas perfect for unwinding. Experience the blend of functionality and comfort at Creekside by scheduling a tour today, and discover why our apartments are the ideal place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overland Park Apartments with Dishwasher",
      "seo_description": "Explore Overland Park apartments at Creekside with a dishwasher in each unit. Enjoy modern convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "creekside-apartment-with-swimming-pool",
      "search_query": "apartment with swimming pool in Creekside neighborhood",
      "category": "Amenity",
      "h1_title": "Apartment with Swimming Pool in Creekside",
      "h2_subtitle": "Dive into comfort at Creekside Apartments with a refreshing swimming pool. Experience luxury living in your new home today.",
      "page_copy": "Welcome to Creekside Apartment Homes, located in the desirable Creekside neighborhood of Overland Park, KS. Our community offers elegant one-, two-, and three-bedroom apartments designed with your lifestyle in mind. Among our many amenities, enjoy our refreshing swimming pool—a perfect spot to unwind and enjoy sunny days with friends or family.\n\nCreekside Apartment Homes not only provides a luxurious swimming pool but also features thoughtfully designed living spaces with stainless steel appliances, washer and dryer in every unit, and cable-ready access. Our community location offers the benefit of nearby shopping and easy access to major highways, making daily commutes pleasantly short. Enjoy the natural beauty of nearby parks and trails all while residing in a peaceful, smoke-free environment. Schedule your visit today and see what makes Creekside the ideal place to make your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Swimming Pool Apartments in Creekside",
      "seo_description": "Discover Creekside apartments with a swimming pool in Overland Park. Experience luxury living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-overland-park",
      "search_query": "one bedroom apartments overland park",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Overland Park",
      "h2_subtitle": "Explore modern one-bedroom apartments in Overland Park at Creekside. Enjoy a lifestyle of comfort and convenience today.",
      "page_copy": "Discover the perfect one-bedroom apartment at Creekside Apartment Homes in Overland Park, KS. Our community offers modern living spaces with everyday comforts such as stainless steel appliances, cable readiness, and a washer and dryer in every unit. Located in the serene Creekside neighborhood, our smoke-free community provides direct access to local shopping, dining, and nearby highways.\n\nOur one-bedroom apartments are thoughtfully designed to provide ample living space and easy access to community amenities like inviting parks and trails. Whether you're relaxing at home or exploring the vibrant Overland Park area, Creekside offers a blend of convenience and tranquility. Schedule a private tour today and experience why our one-bedroom apartments are the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Overland Park",
      "seo_description": "Find modern one-bedroom apartments in Overland Park at Creekside. Enjoy community amenities and local conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-creekside-johnson-county",
      "search_query": "two bedroom apartments creekside johnson county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Creekside, Johnson County",
      "h2_subtitle": "Discover spacious two-bedroom apartments in the charming Creekside neighborhood, Johnson County. Enjoy convenience and comfort at its best.",
      "page_copy": "Welcome to Creekside Apartment Homes, nestled in the heart of Johnson County's picturesque Creekside neighborhood. Our spacious two-bedroom apartments offer a perfect blend of style and practicality, complete with modern amenities such as stainless steel appliances and in-unit washers and dryers. Conveniently cable-ready, these homes offer the ease of entertainment right at your fingertips.\n\nEnjoy serene living with easy access to local highways and shopping centers, making errands and commutes a breeze. Creekside's community features smoke-free living and inviting spaces ideal for relaxation and recreation. Just steps from scenic parks and trails, our two-bedroom apartments provide the ideal home base for exploring the best of what Overland Park has to offer. Visit us today, and see why Creekside is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Creekside, KS",
      "seo_description": "Explore two-bedroom apartments in Creekside, Johnson County, with modern amenities and easy access to local conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-66213",
      "search_query": "three bedroom apartments near 66213",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 66213",
      "h2_subtitle": "Explore spacious three-bedroom apartments near the 66213 area at Creekside. Enjoy the perfect blend of comfort and convenience today.",
      "page_copy": "Discover the ultimate in spacious living at Creekside Apartment Homes, conveniently located near the 66213 zip code in Overland Park. Our three-bedroom apartments are designed to meet the needs of modern families, offering ample living space paired with high-end features like stainless steel appliances, in-unit washers and dryers, and cable readiness.\n\nSituated in the tranquil Creekside neighborhood, our community offers more than just a place to live. With close proximity to highways, shopping centers, and local parks, you'll enjoy both convenience and community. Our smoke-free environment and inviting shared spaces make Creekside the ideal destination for families seeking a balanced lifestyle in a vibrant setting. Schedule a tour today and see what makes our three-bedroom offerings the perfect choice near the 66213 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 66213",
      "seo_description": "Find spacious three-bedroom apartments near 66213 at Creekside. Ideal for families seeking comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "apartments-near-pleasant-ridge-elementary",
      "search_query": "apartments near Pleasant Ridge Elementary Overland Park",
      "category": "School",
      "h1_title": "Apartments Near Pleasant Ridge Elementary",
      "h2_subtitle": "Discover family-friendly apartments near Pleasant Ridge Elementary in Overland Park. Experience comfortable living at Creekside.",
      "page_copy": "Located just a short distance from Pleasant Ridge Elementary, Creekside Apartment Homes offers an ideal setting for families in Overland Park. Our community features a selection of one-, two-, and three-bedroom apartments that cater to the needs of growing families. Each unit comes equipped with stainless steel appliances, cable readiness, and in-home washers and dryers for added convenience.\n\nSurrounded by lush trails and parks, Creekside provides a serene, smoke-free environment while maintaining easy access to local shopping and highways. Living near Pleasant Ridge Elementary means not only enjoying a short commute for school drop-offs but also being part of a vibrant community focused on quality education and family values. Come tour Creekside and discover why our apartments are the ideal choice near Pleasant Ridge Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pleasant Ridge Elementary",
      "seo_description": "Find family-friendly apartments near Pleasant Ridge Elementary at Creekside, offering comfort and convenience in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "creekside-apartments-close-to-bentwood-elementary",
      "search_query": "Creekside apartments close to Bentwood Elementary",
      "category": "School",
      "h1_title": "Creekside Apartments Near Bentwood Elementary",
      "h2_subtitle": "Find the perfect home at Creekside Apartments, conveniently located close to Bentwood Elementary in Overland Park. Enjoy family-friendly living.",
      "page_copy": "Creekside Apartment Homes offers a welcoming community just minutes from Bentwood Elementary in Overland Park. Our selection of one-, two-, and three-bedroom apartments is designed with family living in mind, providing comfortable and spacious floor plans with stainless steel appliances and in-unit laundry facilities.\n\nSet in the tranquil Creekside neighborhood, our apartments provide the ideal balance of accessibility and peace. Enjoy the convenience of nearby highways, shopping areas, and beautiful parks, all contributing to a vibrant local atmosphere. Our smoke-free community fosters a healthy living environment perfect for families with school-aged children attending Bentwood Elementary. Visit us today to explore why Creekside Apartment Homes is the perfect family-friendly choice near Bentwood Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Creekside Apartments Near Bentwood Elementary",
      "seo_description": "Discover Creekside Apartments near Bentwood Elementary in Overland Park, offering convenience and family-friendly amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "oak-hill-elementary-nearby-apartments-66213",
      "search_query": "Oak Hill Elementary nearby apartments 66213",
      "category": "School",
      "h1_title": "Apartments Near Oak Hill Elementary 66213",
      "h2_subtitle": "Explore spacious apartments close to Oak Hill Elementary near the 66213 zip code. Creekside is ideal for families seeking comfort and convenience.",
      "page_copy": "Nestled in the heart of Overland Park, Creekside Apartment Homes offers convenient living near Oak Hill Elementary within the 66213 area. Our community features a variety of one-, two-, and three-bedroom apartment homes equipped with modern amenities including stainless steel appliances and in-unit washers and dryers to ensure a comfortable living experience.\n\nFamilies will appreciate the close proximity to Oak Hill Elementary, making school commutes a breeze and creating a nurturing environment for children. Situated near highways and shopping centers, our smoke-free community provides both ease and calm. The inviting community spaces and access to local trails make Creekside the perfect spot for families who value both convenience and an active lifestyle. Discover your new home at Creekside today, and enjoy all the benefits of living near Oak Hill Elementary in the 66213 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Oak Hill Elementary 66213",
      "seo_description": "Find comfortable, family-friendly apartments near Oak Hill Elementary in the 66213 area at Creekside.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "apartments-near-california-trail-middle-school-ks",
      "search_query": "apartments near California Trail Middle School KS",
      "category": "School",
      "h1_title": "Apartments Near California Trail Middle School",
      "h2_subtitle": "Discover ideal apartments near California Trail Middle School in KS. Creekside offers convenience and comfort for families.",
      "page_copy": "Creekside Apartment Homes in Overland Park, KS, provides the perfect location for families with children attending California Trail Middle School. Our community features a variety of smoke-free one-, two-, and three-bedroom apartments, all equipped with modern amenities such as stainless steel appliances and in-home washers and dryers, ensuring a convenient lifestyle.\n\nOur prime location not only makes the daily school drop-off effortless but also places you close to highways and shopping venues, enhancing your living experience. The community boasts inviting amenities and direct access to local parks and paths, offering a balance of tranquility and accessibility. If you're looking for a community that supports your family’s educational and lifestyle needs, Creekside Apartment Homes near California Trail Middle School is the perfect choice.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near California Trail Middle School",
      "seo_description": "Find family-friendly apartments near California Trail Middle School in KS at Creekside, offering comfort and easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "residences-near-olathe-east-high-school",
      "search_query": "residences near Olathe East High School",
      "category": "School",
      "h1_title": "Residences Near Olathe East High School",
      "h2_subtitle": "Explore our family-friendly residences conveniently located near Olathe East High School in Overland Park. Ideal for easy commutes and comfortable living.",
      "page_copy": "Creekside Apartment Homes provides an ideal living community for families with students attending Olathe East High School. We offer a range of spacious one-, two-, and three-bedroom residences equipped with modern comforts like stainless steel appliances and in-unit washers and dryers, all designed to enhance your quality of living.\n\nOur smoke-free community offers a peaceful environment while being in proximity to major highways, shopping destinations, and scenic nature trails. These conveniences ensure easy commutes and a balanced lifestyle. With inviting community spaces and direct access to nearby parks, Creekside is perfect for families who love the outdoors. Make the move to Creekside Apartment Homes and enjoy the benefits of residing near Olathe East High School today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences Near Olathe East High School",
      "seo_description": "Find ideal family residences near Olathe East High School at Creekside, offering comfort and easy access in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "apartments-close-to-johnson-county-community-college",
      "search_query": "apartments close to Johnson County Community College",
      "category": "School",
      "h1_title": "Apartments Near Johnson County Community College",
      "h2_subtitle": "Discover convenient apartments close to Johnson County Community College. Ideal for students seeking a vibrant and accessible living space in Overland Park.",
      "page_copy": "Situated in the bustling area of Overland Park, Creekside Apartment Homes offers an unmatched living experience close to Johnson County Community College. Our community boasts a selection of smoke-free one-, two-, and three-bedroom apartments, each with modern amenities like stainless steel appliances and in-unit laundry facilities, perfect for students and busy professionals.\n\nLiving at Creekside means you’ll enjoy easy access to major highways and local shopping centers, enhancing your daily routine. The community's direct access to nearby trails and parks provides ample opportunities for relaxation and outdoor activities. Whether you're attending classes or enjoying the vibrant city life, Creekside Apartment Homes is your gateway to a balanced life. Experience the ease and convenience of living just minutes from Johnson County Community College today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Johnson County Community College",
      "seo_description": "Find convenient apartments near Johnson County Community College at Creekside, offering modern amenities and easy access in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "creekside-living-near-cleveland-university-kansas-city",
      "search_query": "Creekside living near Cleveland University Kansas City",
      "category": "School",
      "h1_title": "Creekside Living Near Cleveland University KC",
      "h2_subtitle": "Enjoy Creekside living near Cleveland University Kansas City. Experience comfort and convenience in a welcoming community.",
      "page_copy": "Experience the best of Creekside living in Overland Park, conveniently located near Cleveland University Kansas City. Our spacious apartment homes offer a variety of one-, two-, and three-bedroom floor plans, all featuring modern amenities like stainless steel appliances and in-unit washers and dryers, perfect for students and professionals alike.\n\nCreekside Apartment Homes provides easy access to major highways, making commutes to campus a breeze. Enjoy the community's direct access to local parks and trails, offering a refreshing retreat from the hustle and bustle. Our smoke-free environment and welcoming community spaces are designed to enhance your lifestyle. Choose Creekside for a balanced living experience close to Cleveland University Kansas City today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Creekside Living Near Cleveland University KC",
      "seo_description": "Enjoy Creekside living near Cleveland University Kansas City, offering modern comfort and easy commuting options in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "apartments-near-regents-center-overland-park-ks",
      "search_query": "apartments near Regents Center Overland Park KS",
      "category": "School",
      "h1_title": "Apartments Near Regents Center Overland Park",
      "h2_subtitle": "Explore top-tier apartments near Regents Center in Overland Park, KS, offering a prime location and exceptional amenities.",
      "page_copy": "Creekside Apartment Homes is your premier destination for luxurious living near the Regents Center in Overland Park, KS. Our community offers smoke-free one-, two-, and three-bedroom apartments, each equipped with stainless steel appliances and in-home washers and dryers. These homes are designed for both convenience and comfort, ideal for professionals and families.\n\nLocated in the heart of Overland Park, you'll have direct access to major highways and shopping centers, making daily commutes and errands effortless. Additionally, our welcoming community spaces and nearby parks provide the perfect balance of relaxation and recreation. Choose Creekside Apartment Homes for an enriching living experience just moments away from Regents Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Regents Center Overland Park",
      "seo_description": "Discover convenient living near Regents Center in Overland Park at Creekside, with modern amenities and excellent accessibility.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "apartments-near-overland-park-regional-medical-center",
      "search_query": "apartments near Overland Park Regional Medical Center",
      "category": "Hospital",
      "h1_title": "Apartments Near Overland Park Regional Medical Center",
      "h2_subtitle": "Find exceptional apartments near Overland Park Regional Medical Center. Enjoy modern amenities and convenient access in Overland Park, KS.",
      "page_copy": "At Creekside Apartment Homes, you’ll find the ideal living environment near Overland Park Regional Medical Center. Offering one-, two-, and three-bedroom apartments, each residence features in-home washers and dryers, stainless steel appliances, and are cable ready, ensuring a modern and hassle-free lifestyle.\n\nOur community is perfectly positioned with easy access to major highways, facilitating quick commutes to the medical center and surrounding areas. Residents can also enjoy nearby parks and inviting community spaces for relaxation and leisure. Whether you're a medical professional or simply want proximity to healthcare facilities, Creekside Apartment Homes provides excellent living solutions in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Park Regional Medical Center",
      "seo_description": "Explore modern living near Overland Park Regional Medical Center at Creekside. Experience comfort and convenience in Overland Park, KS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "creekside-apartments-by-childrens-mercy-kansas",
      "search_query": "Creekside apartments by Children's Mercy Kansas",
      "category": "Hospital",
      "h1_title": "Creekside Apartments by Children's Mercy Kansas",
      "h2_subtitle": "Discover Creekside Apartments, located conveniently by Children's Mercy Kansas. Experience tranquil living with modern amenities.",
      "page_copy": "Creekside Apartment Homes offers an exceptional living experience near Children's Mercy Kansas. Choose from a variety of one-, two-, and three-bedroom apartments, each thoughtfully designed with features like stainless steel appliances and in-unit washers and dryers. Our smoke-free community ensures a clean environment for families and professionals alike.\n\nPositioned in Overland Park, KS, Creekside provides easy access to major thoroughfares, simplifying travel to the hospital and beyond. Benefit from direct access to nearby parks and natural trails for a serene escape after a busy day. Make Creekside Apartments your home and enjoy a community where comfort and convenience harmonize near Children's Mercy Kansas.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Creekside Apartments by Children's Mercy Kansas",
      "seo_description": "Live comfortably near Children's Mercy Kansas at Creekside Apartments, offering modern amenities and easy access in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "adventhealth-south-overland-park-hospital-nearby-apartments",
      "search_query": "AdventHealth South Overland Park Hospital nearby apartments",
      "category": "Hospital",
      "h1_title": "Apartments Near AdventHealth South Overland Park",
      "h2_subtitle": "Explore nearby apartments to AdventHealth South Overland Park Hospital. Enjoy comfort and convenience in a prime Overland Park, KS location.",
      "page_copy": "Creekside Apartment Homes provides excellent living options near AdventHealth South Overland Park Hospital. Our community features smoke-free one-, two-, and three-bedroom apartments, equipped with modern amenities such as stainless steel appliances and in-home washers and dryers, making them the perfect choice for healthcare professionals and families alike.\n\nSituated in Overland Park, our apartment homes offer easy highway access, ensuring effortless commutes to the hospital and surrounding areas. Residents appreciate the inviting community spaces and direct access to local parks, ideal for relaxation and recreation. Experience a blend of peace and accessibility by choosing Creekside Apartment Homes near AdventHealth South Overland Park Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near AdventHealth South Overland Park",
      "seo_description": "Find modern apartments near AdventHealth South Overland Park Hospital at Creekside. Enjoy convenience and amenities in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "apartments-near-thomas-s-stoll-memorial-park-overland-park",
      "search_query": "apartments near Thomas S. Stoll Memorial Park Overland Park",
      "category": "Park",
      "h1_title": "Apartments Near Thomas S. Stoll Memorial Park",
      "h2_subtitle": "Live near Thomas S. Stoll Memorial Park in Overland Park with our thoughtfully designed apartments. Enjoy modern living with nature access.",
      "page_copy": "Nestled close to Thomas S. Stoll Memorial Park, Creekside Apartment Homes offers residents a perfect blend of nature and urban convenience. Our smoke-free one-, two-, and three-bedroom apartments come equipped with features like stainless steel appliances, in-home washers and dryers, and are cable ready, ensuring a modern living experience.\n\nOur location in Overland Park provides easy access to nearby highways and shopping centers, making errands and commutes a breeze. Enjoy the tranquility of being near the park, which provides ample opportunities for outdoor activities and relaxation. Choose Creekside Apartment Homes and enjoy both the excitement of city life and the serenity of nature at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Thomas S. Stoll Memorial Park",
      "seo_description": "Experience modern living near Thomas S. Stoll Memorial Park at Creekside Apartment Homes. Enjoy convenience, amenities, and natural beauty in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "creekside-apartments-close-to-quivira-park",
      "search_query": "Creekside apartments close to Quivira Park",
      "category": "Park",
      "h1_title": "Creekside Apartments Close to Quivira Park",
      "h2_subtitle": "Find your perfect home at Creekside Apartments near Quivira Park. Enjoy a peaceful lifestyle with modern amenities close to nature.",
      "page_copy": "Creekside Apartment Homes, located close to Quivira Park, offers a harmonious blend of modern living and nature's beauty. Our community provides smoke-free one-, two-, and three-bedroom apartments with features such as stainless steel appliances and washers and dryers in each unit, making everyday living both comfortable and convenient.\n\nSituated in the vibrant area of Overland Park, our residents enjoy easy access to the scenic beauty of Quivira Park as well as convenient highway routes and shopping outlets. Embrace outdoor activities or a leisurely stroll in the park, then return to the comfort and convenience of Creekside Apartments. Experience the best of both worlds with Creekside Apartment Homes close to Quivira Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Creekside Apartments Close to Quivira Park",
      "seo_description": "Live near Quivira Park at Creekside Apartments—offering modern amenities and convenient access to nature and city life in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "oak-park-adjacent-apartments-johnson-county",
      "search_query": "Oak Park adjacent apartments in Johnson County",
      "category": "Park",
      "h1_title": "Oak Park Adjacent Apartments in Johnson County",
      "h2_subtitle": "Discover Creekside Apartment Homes, adjacent to Oak Park in Johnson County. Enjoy modern living with excellent access to local amenities.",
      "page_copy": "Experience premium living at Creekside Apartment Homes, ideally situated adjacent to Oak Park in Johnson County. Our smoke-free, one-, two-, and three-bedroom apartments feature modern amenities such as stainless steel appliances and in-house washers and dryers, making them the perfect place to call home.\n\nLocated in the heart of Overland Park, our community offers easy access to highways and shopping, ensuring you're never far from what you need. Nestled near Oak Park, our residents can enjoy tranquil surroundings and outdoor recreational opportunities while remaining close to the vibrant city life of Johnson County. Choose Creekside Apartment Homes for an unparalleled living experience adjacent to Oak Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Oak Park Adjacent Apartments, Johnson County",
      "seo_description": "Find your new home at Creekside Apartments adjacent to Oak Park in Johnson County. Enjoy modern amenities and convenient access to Overland Park attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "valleybrooke-park-nearby-apartment-living-66213",
      "search_query": "Valleybrooke Park nearby apartment living in 66213",
      "category": "Park",
      "h1_title": "Valleybrooke Park Nearby Living in 66213",
      "h2_subtitle": "Enjoy apartment living near Valleybrooke Park in the 66213 area. Creekside Apartment Homes offers modern comforts and a great location.",
      "page_copy": "Located just a short distance from Valleybrooke Park, Creekside Apartment Homes in the 66213 area offers the perfect blend of urban accessibility and park-side tranquility. Our smoke-free community provides spacious one-, two-, and three-bedroom apartments equipped with modern conveniences like stainless steel appliances and in-home washers and dryers.\n\nLiving at Creekside means having easy access to local shopping centers and highways while enjoying the serene surroundings of Valleybrooke Park. Whether you're exploring the park's scenic paths or simply unwinding in your comfortable apartment, you’ll find a harmonious balance of leisure and lifestyle. Discover the possibilities of nearby apartment living at Creekside Apartment Homes, where nature and modernity meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Valleybrooke Park Nearby Living in 66213",
      "seo_description": "Discover apartment living near Valleybrooke Park in 66213 at Creekside Apartments. Modern amenities plus easy access to parks and shopping.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "apartments-by-indian-valley-overland-park",
      "search_query": "apartments by Indian Valley Overland Park",
      "category": "Park",
      "h1_title": "Apartments by Indian Valley, Overland Park",
      "h2_subtitle": "Explore Creekside Apartment Homes situated by Indian Valley in Overland Park. Spacious living with convenient access to local amenities.",
      "page_copy": "Creekside Apartment Homes, ideally located by Indian Valley in Overland Park, KS, offers a modern retreat surrounded by natural beauty and urban conveniences. Our community features smoke-free one-, two-, and three-bedroom apartments, all equipped with high-end stainless steel appliances and in-unit washers and dryers for ultimate convenience.\n\nPositioned perfectly in Johnson County, residents of Creekside Apartment Homes enjoy easy access to major highways and local shopping centers while savoring the peaceful atmosphere near Indian Valley. Whether you're exploring nearby trails or enjoying the vibrant community spaces, Creekside provides a lifestyle that is both comfortable and connected. Discover your ideal home near Indian Valley in Overland Park today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Indian Valley, Overland Park",
      "seo_description": "Find your new home at Creekside Apartments near Indian Valley in Overland Park. Modern amenities and easy access to highways and parks.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "rosehill-east-park-proximate-apartments-creekside",
      "search_query": "Rosehill East Park proximate apartments in Creekside",
      "category": "Park",
      "h1_title": "Rosehill East Park Proximate Apartments",
      "h2_subtitle": "Live near Rosehill East Park at Creekside Apartment Homes. Enjoy modern living in a prime proximite location.",
      "page_copy": "Nestled in the vibrant community of Creekside, our apartments offer proximity to the serene Rosehill East Park, providing residents with a perfect balance of nature and urban living. Creekside Apartment Homes features smoke-free one-, two-, and three-bedroom layouts, complete with stainless steel appliances and in-unit washers and dryers, ensuring a comfortable and convenient lifestyle.\n\nLocated in Overland Park, KS, and within easy reach of roads and shopping districts, our community not only offers park-side living but also ensures you're never far from city amenities. Enjoy the tranquility offered by nearby Rosehill East Park while relishing the modern comforts of your home at Creekside Apartment Homes. Discover the ideal living experience with us today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rosehill East Park Proximate Apartments",
      "seo_description": "Live at Creekside Apartments near Rosehill East Park. Enjoy modern amenities in a prime location proximate to parks and city conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "bluejacket-park-surrounding-apartments-overland-park",
      "search_query": "Bluejacket Park surrounding apartments Overland Park KS",
      "category": "Park",
      "h1_title": "Bluejacket Park Surrounding Apartments",
      "h2_subtitle": "Discover apartments surrounding Bluejacket Park in Overland Park, KS. Experience Creekside Apartment Homes' modern living and prime location.",
      "page_copy": "Experience the charm of living near Bluejacket Park with Creekside Apartment Homes, where the beauty of Overland Park, KS, is right at your doorstep. Our one-, two-, and three-bedroom smoke-free apartments offer modern amenities, including stainless steel appliances and in-unit washers and dryers, tailored to meet your everyday needs.\n\nCreekside Apartment Homes provides easy access to highways and local shopping, all while being nestled close to the serene Bluejacket Park. Enjoy the inviting community spaces within our complex or take a stroll through nearby park trails. With the perfect blend of nature and convenience, Creekside offers a living experience that's both relaxing and accessible. Make Creekside your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bluejacket Park Surrounding Apartments",
      "seo_description": "Find your perfect home at Creekside Apartments near Bluejacket Park in Overland Park, KS. Enjoy modern amenities and a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167594",
      "source": "generator",
      "page_item_url": "apartments-near-kansas-city-airport-overland-park",
      "search_query": "apartments near kansas city international airport overland park",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City Intl Airport",
      "h2_subtitle": "Find convenience at Creekside Apartment Homes located conveniently near Kansas City International Airport in Overland Park.",
      "page_copy": "Creekside Apartment Homes offers the perfect blend of suburban tranquility and urban connectivity, making it an ideal choice for those seeking apartments near Kansas City International Airport in Overland Park. Our smoke-free community boasts well-designed one-, two-, and three-bedroom apartments, each featuring modern stainless steel appliances and in-unit washers and dryers for the ultimate convenience.\n\nSituated in the heart of Overland Park, KS, our community provides easy access to major highways, making commuting to Kansas City International Airport a breeze. Enjoy local shopping and dining hubs nearby while savoring the peaceful park-like setting that surrounds our residences. Discover your new home at Creekside Apartment Homes, where convenient airport access meets cozy living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool area with lounge chairs and landscaping.",
        "public_id": "019fc974-cc7b-77ea-9a84-dcf2809cfa63",
        "storage_key": "property/6767906449167594/019fc974-cc7b-77ea-9a84-dcf2809cfa63.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City Intl Airport",
      "seo_description": "Live at Creekside Apartments in Overland Park, KS. Conveniently located near Kansas City International Airport with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701878070"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PJGV522M"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 7"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/a839cb2b-5e3e-47b5-b89c-f65e946581fc/app.js?nocache=1&gaTracking=G-041W59P004&buttonbgcolor=ad841f&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-357-6269"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImpVbG8zTEg3K1BlcFovYkZ0Sm5ubUE9PSIsInZhbHVlIjoiNVlFK09qWHZlZlN4MVpaaU12YXl6Zz09IiwibWFjIjoiZDRkMzQ0ZTU1NDRlMTNmMTkwZWE2YjhlMGFmOTViNjUzMDBlNWMxZDIwNmU4MzdhYTU1YmNhYTU3ODkyODAwZCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701878070",
  "custom_google_gtm_id": "GTM-PJGV522M",
  "custom_rollout_phase": "Batch 7",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/a839cb2b-5e3e-47b5-b89c-f65e946581fc/app.js?nocache=1&gaTracking=G-041W59P004&buttonbgcolor=ad841f&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-357-6269",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImpVbG8zTEg3K1BlcFovYkZ0Sm5ubUE9PSIsInZhbHVlIjoiNVlFK09qWHZlZlN4MVpaaU12YXl6Zz09IiwibWFjIjoiZDRkMzQ0ZTU1NDRlMTNmMTkwZWE2YjhlMGFmOTViNjUzMDBlNWMxZDIwNmU4MzdhYTU1YmNhYTU3ODkyODAwZCJ9",
  "custom_audioeye_site_id": "d15ca92a-bc66-4da0-8a35-1cab933b08ce",
  "custom_audioeye_site_hash": "2e7e373ede2b7c2a35591bad19cdd28a"
};

export const generatedAt = '2026-11-03T22:59:12.655Z';
